<template>
  <div class="floor2">


<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	  viewBox="0 0 636 285.333" enable-background="new 0 0 636 285.333" xml:space="preserve">
<polygon fill="#8FC3E1" points="40.066,155.139 40.066,163.21 39.914,175.336 39.914,227.146 44.335,227.146 44.281,223.221 
	44.348,223.221 44.348,223.155 70.72,223.155 70.72,223.134 87.659,223.134 87.659,196.102 87.759,196.102 87.759,195.711 
	87.755,195.711 87.646,171.722 87.726,159.657 82.807,155.139 "/>
<path fill="#8FC3E1" d="M237.792,154.374l-74.436,0.613l-5.091,4.102v37.292H88.404v27.498H70.96
	c-0.011,0.167-0.021,0.394-0.021,0.688c0,1.733,0.342,5.503,2.885,9.505c1.026,1.615,3.15,4.316,6.362,6.601
	c2.768,1.965,6.339,3.618,10.728,4.044l3.393,0.08c0.392-0.021,0.791-0.053,1.194-0.093l4.569-0.813
	c6.923-1.539,11.228-2.479,18.456-4.162l8.006-1.886c2.647-0.629,5.646-1.346,9.113-2.179l34.322-8.389l6.813-1.623l0.04-3.446
	h0.041l0-0.075h10.951l-0.046,5.393l17.121,0.017l0.133-14.744l13.48,0.024v-35.55l18.641-0.25L237.792,154.374z"/>
<polygon fill="#D9E09E" points="575.616,100.682 575.74,94.83 596.219,94.83 593.022,94.712 593.342,92.224 596.213,92.096 
	596.148,82.878 569.005,82.878 561.355,90.569 543.793,90.569 543.793,102.375 552.669,110.804 570.036,110.74 570.999,110.719 
	571.149,100.649 "/>
<text transform="matrix(1 0 0 1 552.3262 104.7227)" fill="#000100" font-family="Montserrat" font-size="3.9729">C-236</text>
<text transform="matrix(1 0 0 1 549.9238 99.6929)" fill="#000100" font-family="Montserrat" font-size="3.9729">Lighting</text>
<text transform="matrix(1 0 0 1 545.0566 95.2236)" fill="#000100" font-family="Montserrat" font-size="3.9729">Wired Custom</text>
<polygon fill="#D9E09E" points="444.798,88.589 474.349,88.533 445.064,88.533 444.785,88.42 "/>
<polygon fill="#D9E09E" points="575.74,94.83 575.616,100.682 571.15,100.649 570.998,110.719 575.783,110.612 578.208,110.677 
	591.681,110.74 596.407,110.677 596.535,94.842 596.219,94.83 "/>
<polygon fill="#D9E09E" points="486.186,154.711 486.186,198.001 488.356,197.518 497.184,195.726 504.463,194.066 529.387,188.417 
	529.387,154.68 "/>
<text transform="matrix(1 0 0 1 491.9473 168.959)" fill="#000100" font-family="Montserrat" font-size="5.3833">Eggersmann</text>
<text transform="matrix(1 0 0 1 496.7168 175.0635)" fill="#000100" font-family="Montserrat" font-size="5.3833">Kitchens</text>
<text transform="matrix(1 0 0 1 499.2744 182.0029)" fill="#000100" font-family="Montserrat" font-size="5.3833">C-262</text>
<polygon fill="#D9E09E" points="529.387,154.68 529.387,188.417 531.792,187.872 543.909,184.915 546.797,184.744 546.955,181.56 
	543.793,154.67 "/>
<polygon fill="#D9E09E" points="595.652,133.97 543.84,133.97 543.793,154.669 546.955,181.559 550.373,181.552 550.373,182.638 
	550.436,183.658 563.589,183.722 564.483,180.019 595.707,173.762 595.707,172.995 "/>
<g>
	<text transform="matrix(-0.005 -1 1 -0.005 534.5313 163.6328)" font-family="Montserrat" font-size="4.5001">i</text>
	<text transform="matrix(-0.005 -1 1 -0.005 534.5391 165.3691)" font-family="Montserrat" font-size="4.5001">f</text>
	<text transform="matrix(-0.005 -1 1 -0.005 534.5547 168.3027)" font-family="Montserrat" font-size="4.5001">o</text>
	<text transform="matrix(-0.005 -1 1 -0.005 534.5693 171.1367)" font-family="Montserrat" font-size="4.5001">S</text>
	<text transform="matrix(-0.005 -1 1 -0.005 534.5742 172.3711)" font-family="Montserrat" font-size="4.5001"> </text>
	<text transform="matrix(-0.005 -1 1 -0.005 534.5879 175.0117)" font-family="Montserrat" font-size="4.5001">a</text>
	<text transform="matrix(-0.005 -1 1 -0.005 534.5977 176.7988)" font-family="Montserrat" font-size="4.5001">r</text>
	<text transform="matrix(-0.005 -1 1 -0.005 534.6113 179.4404)" font-family="Montserrat" font-size="4.5001">a</text>
	<text transform="matrix(-0.005 -1 1 -0.005 534.623 181.9863)" font-family="Montserrat" font-size="4.5001">L</text>
</g>
<g>
	<text transform="matrix(-0.005 -1 1 -0.005 539.501 167.2559)" font-family="Montserrat" font-size="4.0001"> </text>
	<text transform="matrix(-0.005 -1 1 -0.005 539.5098 169.2783)" font-family="Montserrat" font-size="4.0001">s</text>
	<text transform="matrix(-0.005 -1 1 -0.005 539.5234 171.8623)" font-family="Montserrat" font-size="4.0001">n</text>
	<text transform="matrix(-0.005 -1 1 -0.005 539.5352 174.335)" font-family="Montserrat" font-size="4.0001">e</text>
	<text transform="matrix(-0.005 -1 1 -0.005 539.5488 176.9209)" font-family="Montserrat" font-size="4.0001">h</text>
	<text transform="matrix(-0.005 -1 1 -0.005 539.5605 179.2236)" font-family="Montserrat" font-size="4.0001">c</text>
	<text transform="matrix(-0.005 -1 1 -0.005 539.5693 180.8965)" font-family="Montserrat" font-size="4.0001">t</text>
	<text transform="matrix(-0.005 -1 1 -0.005 539.5742 181.9912)" font-family="Montserrat" font-size="4.0001">i</text>
	<text transform="matrix(-0.005 -1 1 -0.005 539.5879 184.8066)" font-family="Montserrat" font-size="4.0001">K</text>
</g>
<text transform="matrix(-0.005 -1 1 -0.005 539.6133 166.6094)" font-family="Montserrat" font-size="3.5">C-265</text>
<polygon fill="#D9E09E" points="596.088,74.089 591.299,73.707 582.359,44.463 561.67,44.463 561.67,61.238 550.779,61.255 
	541.31,70.814 541.31,78.261 543.793,78.303 543.793,90.569 561.355,90.569 569.005,82.878 596.148,82.878 "/>
<text transform="matrix(1 0 0 1 555.7422 76.0947)" font-family="Montserrat" font-size="5.4855">Scavolini</text>
<text transform="matrix(1 0 0 1 558.8242 70.2305)" font-family="Montserrat" font-size="5.4855">C-232</text>
<polygon fill="#D9E09E" points="447.356,154.738 447.508,175.619 444.762,175.548 444.762,184.906 458.617,185.063 458.807,185.666 
	458.807,154.73 "/>
<polygon points="450.101,175.654 450.846,177.051 450.117,178.458 451.678,178.18 452.791,179.31 453.009,177.74 454.425,177.028 
	452.998,176.335 452.763,174.77 451.662,175.912 "/>
<g>
	<defs>
		<rect id="SVGID_1_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_2_">
		<use xlink:href="#SVGID_1_"  overflow="visible"/>
	</clipPath>
	<path clip-path="url(#SVGID_2_)" fill="none" stroke="#000100" stroke-width="0.3" stroke-miterlimit="10" d="M452.572,176.964
		c0,0-7.97,7.59-0.315,21.763"/>
</g>
<text transform="matrix(1 -0.0025 0.0025 1 441.9297 202.3828)" font-family="Montserrat" font-size="5.3833">Holzsch</text>
<text transform="matrix(1 -0.0025 0.0025 1 445.7422 207.5488)" font-family="Montserrat" font-size="5">C-272</text>
<g>
	<defs>
		<rect id="SVGID_3_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_4_">
		<use xlink:href="#SVGID_3_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_4_)" fill="#D9E09E" points="458.807,154.73 458.807,185.666 459.319,187.298 460.701,190.207 
		462.064,191.831 463.664,193.801 466.382,196.167 470.578,198.447 475.352,199.545 481.524,199.038 486.186,198.001 
		486.186,154.711 	"/>
</g>
<text transform="matrix(1 0 0 1 463.2979 180.0518)" font-family="Montserrat" font-size="5.3833">C-270 </text>
<text transform="matrix(1 0 0 1 460.1484 173.7959)" font-family="Montserrat" font-size="5.3833">Snaidero</text>
<g>
	<defs>
		<rect id="SVGID_5_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_6_">
		<use xlink:href="#SVGID_5_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_6_)" fill="#D9E09E" points="455.147,96.918 447.885,96.964 447.885,145.221 447.885,148.604 
		463.61,148.654 463.61,105.155 	"/>
	<polygon clip-path="url(#SVGID_6_)" fill="#D9E09E" points="445.145,89.227 447.885,91.969 447.885,96.389 448.298,92.059 	"/>
	<polygon clip-path="url(#SVGID_6_)" fill="#D9E09E" points="415.565,89.001 444.204,89.001 447.929,92.196 447.448,148.275 
		415.856,148.381 	"/>
	<polygon clip-path="url(#SVGID_6_)" fill="#D9E09E" points="550.78,61.256 561.67,61.239 561.67,44.463 540.663,44.463 
		535.109,44.335 534.917,46.953 531.597,46.953 528.915,49.826 528.98,78.049 541.31,78.26 541.31,70.815 	"/>
	<polygon clip-path="url(#SVGID_6_)" fill="#D9E09E" points="472.39,113.7 463.61,105.155 463.61,148.653 487.92,148.73 
		497.179,140.942 497.179,113.7 	"/>
</g>
<text transform="matrix(1 0 0 1 475.0908 135.6938)" fill="#000100" font-family="Montserrat" font-size="4.7432">C-212</text>
<text transform="matrix(1 0 0 1 467.2979 123.9399)" fill="#000100" font-family="Montserrat" font-size="4.7432">Downsview </text>
<text transform="matrix(1 0 0 1 467.2979 129.6318)" fill="#000100" font-family="Montserrat" font-size="4.7432">Kitchens</text>
<g>
	<defs>
		<rect id="SVGID_7_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_8_">
		<use xlink:href="#SVGID_7_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_8_)" fill="#D9E09E" points="474.349,97.531 474.349,88.533 444.798,88.589 444.82,88.902 
		445.145,89.228 448.297,92.058 447.885,96.388 447.885,96.964 455.147,96.918 472.39,113.699 497.179,113.699 497.179,97.531 
		474.464,97.531 	"/>
	<polygon clip-path="url(#SVGID_8_)" fill="#D9E09E" points="497.243,78.049 498.94,78.015 498.94,70.229 489.7,61.08 479.62,61.08 
		479.62,49.266 476.885,48.224 476.874,48.356 444.694,56.659 444.767,88.141 444.786,88.419 445.063,88.534 474.349,88.534 
		474.463,97.532 497.178,97.532 497.178,95.225 	"/>
</g>
<text transform="matrix(1 0 0 1 462.7393 77.3677)" fill="#000100" font-family="Montserrat" font-size="5.4855">C-220</text>
<text transform="matrix(1 0 0 1 448.6582 71.2354)" fill="#000100" font-family="Montserrat" font-size="4.9662">Armazem Design</text>
<g>
	<defs>
		<rect id="SVGID_9_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_10_">
		<use xlink:href="#SVGID_9_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_10_)" fill="#D9E09E" points="508.35,48.643 507.984,47.399 504.856,47.144 504.856,44.335 
		476.698,44.398 476.389,48.096 479.123,49.138 479.123,60.952 489.203,60.952 498.443,70.101 498.443,77.886 503.068,77.792 
		511.759,77.836 511.759,48.767 	"/>
</g>
<text transform="matrix(1 0 0 1 492.1416 59.3359)" fill="#000100" font-family="Montserrat" font-size="5.4855">C-224</text>
<g>
	<defs>
		<rect id="SVGID_11_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_12_">
		<use xlink:href="#SVGID_11_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_12_)" points="494.236,54.51 493.398,53.167 491.814,53.097 492.836,51.883 492.412,50.354 
		493.88,50.949 495.203,50.077 495.092,51.657 496.333,52.643 494.792,53.027 	"/>
	<path clip-path="url(#SVGID_12_)" d="M492.835,51.591c-5.896-2.147-10.206-4.106-13.193-5.903c-2.984-1.795-4.639-3.437-5.22-4.898
		l-0.219,0.136c0.637,1.576,2.329,3.224,5.334,5.034c3.005,1.808,7.327,3.772,13.229,5.922L492.835,51.591z"/>
</g>
<text transform="matrix(1 0 0 1 446.6279 40.1172)" fill="#000100" font-family="Montserrat" font-size="5.4855">NEFF Beautiful Living</text>
<g>
	<defs>
		<rect id="SVGID_13_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_14_">
		<use xlink:href="#SVGID_13_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_14_)" fill="#D9E09E" points="512.256,77.964 528.851,78.048 528.884,62.909 512.256,62.909 
		512.256,65.795 	"/>
</g>
<text transform="matrix(1 0 0 1 513.5889 73.832)" fill="#000100" font-family="Montserrat" font-size="4">C-228B</text>
<text transform="matrix(1 0 0 1 507.3809 23.665)" font-family="Montserrat" font-size="5.4855">Edward Fields</text>
<g>
	<defs>
		<rect id="SVGID_15_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_16_">
		<use xlink:href="#SVGID_15_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_16_)" fill="#D9E09E" points="517.479,48.896 512.256,48.896 512.256,62.908 528.884,62.908 
		528.914,49.061 	"/>
</g>
<text transform="matrix(1 0 0 1 513.5889 60.0381)" fill="#000100" font-family="Montserrat" font-size="4">C-228A</text>
<text transform="matrix(1 0 0 1 475.0908 30.5034)" fill="#000100" font-family="Montserrat" font-size="5.4855">Tai Ping Carpets</text>
<g>
	<defs>
		<rect id="SVGID_17_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_18_">
		<use xlink:href="#SVGID_17_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_18_)" points="522.213,70.229 521.375,68.886 519.791,68.816 520.813,67.602 520.389,66.074 
		521.856,66.668 523.18,65.796 523.069,67.375 524.31,68.362 522.77,68.747 	"/>
	<path clip-path="url(#SVGID_18_)" fill="none" stroke="#000000" stroke-width="0.3" stroke-miterlimit="10" d="M531.847,25.483
		c0,0,7.064,32.469-9.428,42.19"/>
	<polygon clip-path="url(#SVGID_18_)" points="521.535,54.767 520.481,53.585 518.909,53.785 519.709,52.416 519.032,50.981 
		520.58,51.317 521.736,50.234 521.896,51.811 523.284,52.571 521.833,53.211 	"/>
	<path clip-path="url(#SVGID_18_)" fill="none" stroke="#000000" stroke-width="0.3" stroke-miterlimit="10" d="M520.242,52.444
		c0,0-13.019-5.399-14.465-20.856"/>
	<polygon clip-path="url(#SVGID_18_)" fill="#D9E09E" points="595.642,126.32 593.152,126.384 593.022,124.596 596.343,124.596 
		596.343,115.848 592.065,115.848 580.892,115.721 570.164,115.785 553.371,115.848 552.478,115.913 543.857,126.256 
		543.841,133.97 595.652,133.97 	"/>
</g>
<text transform="matrix(1 0 0 1 552.8418 123.126)" fill="#000100" font-family="Montserrat" font-size="5.3833">SieMatic</text>
<text transform="matrix(1 0 0 1 557.4844 128.7061)" font-family="Montserrat" font-size="4.7432">C-250</text>
<g>
	<defs>
		<rect id="SVGID_19_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_20_">
		<use xlink:href="#SVGID_19_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_20_)" fill="#C4E1F6" points="415.499,201.711 396.779,201.711 371.348,174.371 363.974,174.371 
		363.974,191.315 284.073,191.631 284.264,226.686 306.329,232.221 332.519,238.565 351.959,243.065 355.199,243.696 
		359.159,244.461 361.634,244.686 366.179,244.506 369.194,243.876 370.949,243.156 374.414,241.355 377.069,239.466 
		380.264,236.36 382.019,233.661 383.099,230.826 383.954,226.596 384.33,222.903 410.729,222.906 410.729,227.406 415.499,227.496 
			"/>
</g>
<text transform="matrix(1 0 0 1 335.6582 215.2891)" fill="#000100" font-family="Montserrat" font-size="5.4855">Baker Furniture</text>
<text transform="matrix(1 0 0 1 344.4023 222.3604)" fill="#000100" font-family="Montserrat" font-size="5.4855">B-260</text>
<g>
	<defs>
		<rect id="SVGID_21_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_22_">
		<use xlink:href="#SVGID_21_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_22_)" fill="#C4E1F6" points="397.105,201.944 416.044,201.944 416.004,175.309 415.851,165.165 
		397.177,165.165 397.177,154.789 388.874,154.711 387.8,154.864 371.582,154.789 367.659,158.514 364.665,161.321 364.665,162.013 
		364.708,174.604 371.674,174.604 	"/>
</g>
<text transform="matrix(1 0 0 1 374.2275 171.501)" fill="#000100" font-family="Montserrat" font-size="5.4855">Cowtan &amp; Tout</text>
<text transform="matrix(1 0 0 1 391.6064 178.7305)" fill="#000100" font-family="Montserrat" font-size="5.4855">B-254</text>
<g>
	<defs>
		<rect id="SVGID_23_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_24_">
		<use xlink:href="#SVGID_23_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_24_)" fill="#C4E1F6" points="332.224,62.768 325.677,61.246 319.92,60.184 316.172,59.115 
		313.72,58.515 308.925,58.318 306.169,58.407 302.793,59.028 299.771,60.007 296.75,61.074 293.994,62.495 291.277,64.415 
		289.472,67.052 287.498,69.523 285.78,72.209 284.59,74.654 284.5,90.78 300.28,106.74 300.28,110.82 301.975,110.82 
		302.113,110.876 302.113,110.853 317.331,110.699 347.914,110.749 347.914,66.563 	"/>
</g>
<text transform="matrix(1 0 0 1 311.0898 90.0542)" fill="#000100" font-family="Montserrat" font-size="5.4855">B-228</text>
<text transform="matrix(1 0 0 1 294.2495 82.8794)" fill="#000100" font-family="Montserrat" font-size="5.4855">Century Furniture</text>
<g>
	<defs>
		<rect id="SVGID_25_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_26_">
		<use xlink:href="#SVGID_25_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_26_)" fill="#C4E1F6" points="272.455,80.053 272.455,89.759 268.165,89.759 268.165,103.109 
		273.145,103.109 284.172,114.149 284.215,120.974 299.035,135.694 302.049,135.694 301.857,110.819 300.28,110.819 300.28,110.669 
		300.28,106.739 284.545,90.959 284.545,90.825 284.5,90.779 284.545,82.744 284.545,80.053 	"/>
</g>
<text transform="matrix(0.7071 0.7071 -0.7071 0.7071 289.0366 117.3496)" fill="#000100" font-family="Montserrat" font-size="3.973">B-218</text>
<g>
	<defs>
		<rect id="SVGID_27_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_28_">
		<use xlink:href="#SVGID_27_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_28_)" fill="#C4E1F6" points="299.333,135.56 284.513,120.84 284.47,114.015 273.442,102.975 
		268.462,102.975 268.462,148.59 290.882,148.61 302.334,139.925 302.347,135.56 	"/>
</g>
<text transform="matrix(1 0 0 1 270.3413 129.7065)" font-family="Montserrat" font-size="5.4855">B-216</text>
<text transform="matrix(1 0 0 1 270.3413 135.6582)" font-family="Montserrat" font-size="5.4855">Bienal</text>
<g>
	<defs>
		<rect id="SVGID_29_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_30_">
		<use xlink:href="#SVGID_29_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_30_)" fill="#C4E1F6" points="268.462,89.625 272.752,89.625 272.752,79.919 284.842,79.919 
		284.888,74.519 259.454,74.181 255.811,89.733 250.629,90.259 250.61,99.114 234.855,99.037 205.418,98.806 205.496,148.532 
		268.462,148.589 268.462,102.975 	"/>
</g>
<text transform="matrix(0.6821 0.7312 -0.7312 0.6821 279.646 92.5332)" fill="#000100" font-family="Montserrat" font-size="4.9662">Mantra</text>
<text transform="matrix(0.6821 0.7312 -0.7312 0.6821 272.0239 92.5332)" fill="#000100" font-family="Montserrat" font-size="5.4855">Furnishings </text>
<g>
	<defs>
		<rect id="SVGID_31_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_32_">
		<use xlink:href="#SVGID_31_"  overflow="visible"/>
	</clipPath>
	<polygon clip-path="url(#SVGID_32_)" fill="#C4E1F6" points="386.71,112.83 391,112.83 391,80.341 390.96,80.341 390.884,77.114 
		380.124,74.423 356.063,68.534 347.915,66.563 347.915,110.749 364.828,110.775 364.828,114.234 364.828,119.28 386.71,119.28 	"/>
	<polygon clip-path="url(#SVGID_32_)" fill="#C4E1F6" points="411.096,75.6 413.293,75.6 411.075,75.549 411.096,80.341 	"/>
	<polygon clip-path="url(#SVGID_32_)" fill="#C4E1F6" points="416.07,88.986 415.519,88.983 415.441,76.148 413.104,76.095 
		410.906,76.095 410.906,80.835 410.906,80.836 390.811,80.835 390.811,113.325 386.521,113.325 386.521,119.775 364.639,119.775 
		364.639,142.476 371.326,149.316 387.774,149.239 388.619,149.239 390.923,149.142 390.849,135.712 397.227,135.712 
		399.688,135.712 401.3,137.249 415.596,137.249 415.602,137.631 416.07,137.25 	"/>
</g>
<text transform="matrix(1 0 0 1 393.8281 112.3955)" fill="#000100" font-family="Montserrat" font-size="4.9662">Ammon</text>
<text transform="matrix(1 0 0 1 392.1582 117.8574)" fill="#000100" font-family="Montserrat" font-size="5.4855">Hickson</text>
<text transform="matrix(1 0 0 1 393.8262 124.314)" fill="#000100" font-family="Montserrat" font-size="5.4855">B-240</text>
<path fill="#8FC3E1" d="M199.758,90.52l-3.319-14.579h-25.331l-0.028-0.343c-0.221-2.815-1.543-5.349-3.587-7.73
	c-2.041-2.379-4.799-4.589-7.833-6.73c-2.729-1.932-6.737-2.477-10.234-2.472c-1.29,0-2.507,0.072-3.566,0.17l0.016,76.402h6.656
	l0.155,13.087l52.074-0.036l-0.019-49.391v-8.376L199.758,90.52z"/>
<path fill="#8FC3E1" d="M45.297,144.024c0.541,0.479,1.269,1.059,2.184,1.617c1.83,1.117,4.403,2.152,7.748,2.153h27.723
	l10.209,0.088l-0.003-12.645h51.971V58.912c-1.433,0.157-2.488,0.344-2.855,0.416c-0.097,0.019-0.145,0.029-0.145,0.029v0
	l-77.389,17.89v2.533H44.347v-4.297h-4.282v56.407c0,0,0.002,0.108,0.016,0.315c0.013,0.208,0.036,0.508,0.075,0.884
	c0.08,0.75,0.229,1.792,0.504,2.95c0.405,1.719,1.092,3.687,2.215,5.347l0.667,0.884c0.212,0.25,0.436,0.491,0.673,0.717
	C44.406,143.168,44.754,143.542,45.297,144.024z"/>
<polygon fill="#C4E1F6" points="300.28,106.74 284.545,90.825 284.545,90.959 "/>
<polygon fill="#D9E09E" points="517.479,48.896 528.914,49.061 528.851,78.048 512.256,77.964 512.256,78.06 529,78.06 529,48.896 
	"/>
<path fill="#E5E8E5" d="M508.708,48.68l3.881,0.43L508.708,48.68z"/>
<path d="M596.292,115.848l-0.372,0.001l0.038,8.441h-3.342v2.431h2.628v46.749l-31.227,6.163l-0.722,3.649h-12.462v-2.32h-4.328
	v3.274h-1.584l-0.043,0.01c-0.002,0.001-0.786,0.189-2.192,0.524c-9.852,2.348-50.162,11.888-64.176,14.188
	c-0.75,0.121-1.492,0.181-2.226,0.181c-4.511,0.001-8.657-2.215-11.757-5.108c-3.102-2.884-5.133-6.456-5.439-8.987l-0.041-0.325
	l-14.053-0.048v-8.84h2.776v-20.813h96.438V126.41l8.493-10.314l43.588,0.123L596.292,115.848l-0.372,0.001L596.292,115.848
	l0.001-0.372l-43.941-0.126l-8.887,10.793v28.129h-96.438v20.815h-2.776v10.326l14.467,0.05l0.002-0.373l-0.369,0.046
	c0.355,2.81,2.473,6.449,5.67,9.44c3.198,2.983,7.505,5.306,12.266,5.309c0.771,0,1.556-0.063,2.347-0.191
	c16.086-2.641,66.415-14.721,66.421-14.722l-0.087-0.362v0.372h2.285v-3.275h2.838v2.321h13.82l0.743-3.761l31.337-6.186v-48.105
	h-2.628v-0.941h3.346l-0.045-9.558l-0.369-0.001L596.292,115.848z"/>
<polygon points="508.29,47.709 508.65,49.265 512.256,49.137 512.229,48.392 509.237,48.5 509.016,47.541 "/>
<polygon points="420.283,168.521 420.283,168.894 433.043,168.894 433.043,158.303 419.911,158.303 419.911,168.894 
	420.283,168.894 420.283,168.521 420.654,168.521 420.654,159.048 432.298,159.048 432.298,168.149 420.283,168.149 
	420.283,168.521 420.654,168.521 "/>
<polygon points="447.125,173.859 441.146,173.859 441.146,163.805 447.125,163.805 447.125,163.061 440.4,163.061 440.4,174.604 
	447.125,174.604 447.125,173.86 "/>
<polyline points="428.725,174.539 441.112,174.539 441.112,173.794 428.725,173.794 "/>
<polyline points="416.001,183.182 444.27,182.863 444.262,182.118 415.993,182.437 "/>
<polygon points="397.087,154.959 415.237,154.959 415.237,164.826 415.982,164.826 415.982,154.214 397.087,154.214 "/>
<line x1="152.055" y1="143.613" x2="152.055" y2="142.868"/>
<line x1="151.664" y1="165.052" x2="152.408" y2="165.052"/>
<polyline points="512.237,49.138 529.418,49.33 529.426,48.585 512.246,48.393 "/>
<polyline points="512.488,77.856 512.488,48.804 511.743,48.804 511.743,77.856 "/>
<polyline points="529.312,77.808 529.312,48.804 528.566,48.804 528.566,77.808 "/>
<polyline points="529.391,49.285 531.861,47.142 531.374,46.578 528.902,48.722 "/>
<polygon points="39.693,163.58 44.612,163.58 44.612,176 39.461,176 39.461,176.745 45.357,176.745 45.357,162.835 39.693,162.835 
	"/>
<polygon points="66.284,148.065 66.284,136.207 80.286,136.207 80.286,148.065 81.031,148.065 81.031,135.461 65.539,135.461 
	65.539,148.065 "/>
<polygon points="77.721,154.894 77.721,157.901 66.284,157.901 66.284,154.894 65.539,154.894 65.539,158.646 78.466,158.646 
	78.466,154.894 "/>
<polygon points="65.591,142.296 76.76,142.296 76.76,148.066 77.504,148.066 77.504,141.551 65.591,141.551 "/>
<line x1="94.174" y1="148.015" x2="93.429" y2="148.015"/>
<polygon points="152.467,144.861 161.287,144.861 165.371,149.029 165.902,148.508 161.6,144.116 152.467,144.116 "/>
<polygon points="187.679,75.565 187.679,78.719 171.815,78.719 171.815,75.565 171.071,75.565 171.071,79.463 188.424,79.463 
	188.424,75.565 "/>
<polygon points="211.401,98.646 211.401,119.112 205.735,119.112 205.735,98.646 204.99,98.646 204.99,119.856 212.146,119.856 
	212.146,98.646 "/>
<polygon points="250.005,98.967 250.005,119.111 244.204,119.111 244.204,98.967 243.459,98.967 243.459,119.856 250.75,119.856 
	250.75,98.967 "/>
<polygon points="250.57,119.856 252.136,119.827 252.114,148.375 252.859,148.376 252.882,119.068 250.556,119.111 "/>
<polygon points="171.381,166.288 171.381,166.66 179.447,166.66 179.447,154.374 171.009,154.374 171.009,166.66 171.381,166.66 
	171.381,166.288 171.753,166.288 171.753,155.119 178.702,155.119 178.702,165.916 171.381,165.916 171.381,166.288 
	171.753,166.288 "/>
<polygon points="179.075,166.288 179.075,166.66 187.142,166.66 187.142,154.374 178.704,154.374 178.704,166.66 179.075,166.66 
	179.075,166.288 179.447,166.288 179.447,155.119 186.396,155.119 186.396,165.916 179.075,165.916 179.075,166.288 
	179.447,166.288 "/>
<polygon points="194.462,159.556 194.091,159.556 194.091,165.916 187.142,165.916 187.142,155.119 194.091,155.119 
	194.091,159.556 194.462,159.556 194.834,159.556 194.834,154.374 186.396,154.374 186.396,166.661 194.834,166.661 
	194.834,159.556 "/>
<polygon points="194.459,159.556 202.747,159.605 202.747,165.698 206.056,165.698 206.056,154.975 205.311,154.975 205.31,164.953 
	203.491,164.953 203.491,158.865 194.464,158.811 194.46,159.556 "/>
<polygon points="284.545,80.053 284.545,79.681 274.607,79.681 267.926,79.681 267.926,74.976 284.173,74.976 284.173,80.053 
	284.545,80.053 284.545,79.681 284.545,80.053 284.917,80.053 284.917,74.231 267.181,74.231 267.181,80.425 274.607,80.425 
	284.917,80.425 284.917,80.053 "/>
<polygon points="268.568,148.5 268.568,90.123 272.86,90.123 272.86,80.357 272.115,80.357 272.115,89.378 267.823,89.378 
	267.823,148.5 "/>
<path fill="none" d="M43.542,142.268l-0.667-0.884C43.082,141.69,43.303,141.986,43.542,142.268z"/>
<path d="M205.485,98.898v-9.12l-5.134-0.003l-3.318-14.579h-25.255c-0.315-2.877-1.694-5.454-3.72-7.813
	c-2.109-2.457-4.912-4.696-7.97-6.854c-2.96-2.08-7.093-2.605-10.663-2.608c-4.08,0-7.434,0.703-7.449,0.706l-0.005,0.001
	L63.996,76.653v2.38H45.092v-4.297h-5.771v57.166v0.005c0.001,0.017,0.048,1.908,0.614,4.301c0.567,2.391,1.645,5.295,3.767,7.318
	c0.158,0.148,0.537,0.555,1.102,1.056c1.699,1.507,5.17,3.959,10.426,3.958h27.72l10.957,0.095l-0.003-12.652h57.892l0.154,13.088
	l53.555-0.038L205.485,98.898z M205.094,123.826v24.78l-33.054,0.081l-6.935-0.041l-12.734-0.081l-0.123-13.046l-58.685,0.042
	l-0.039,12.64l-10.14-0.041l-26.565,0.081l-4.623-0.444l-3.731-1.097l-3.326-2.311l-1.598-2.121
	c-0.238-0.282-0.459-0.578-0.667-0.884l-1.954-2.592l-0.771-3.327l-0.527-2.879l-0.112-57.525h5.356v4.241l19.495,0.155v-0.852
	v-1.542l0.568-0.161l16.467-3.812l25.753-5.963l31.959-7.462l8.151-1.46l3.529,0.041l4.087,0.422l4.557,1.603l3.158,2.396
	l2.92,2.474l2.788,2.653l2.404,4.241l0.921,3.657l25.237-0.128l3.244,14.558l5.07,0.163L205.094,123.826z"/>
<path d="M196.861,75.563l-25.237,0.128l-0.921-3.657l-2.404-4.241l-2.788-2.653l-2.92-2.474l-3.158-2.396l-4.557-1.603l-4.087-0.422
	l-3.529-0.041l-8.151,1.46l-31.959,7.462l-25.753,5.963L64.93,76.901l-0.568,0.161v1.542v0.852l-19.495-0.155v-4.241h-5.356
	l0.112,57.525l0.527,2.879l0.771,3.327l1.954,2.592c-1.124-1.66-1.811-3.628-2.215-5.347c-0.275-1.158-0.424-2.2-0.504-2.95
	c-0.039-0.376-0.062-0.676-0.075-0.884c-0.014-0.207-0.016-0.315-0.016-0.315V75.481h4.282v4.297h20.394v-2.533l77.389-17.89v0
	c0,0,0.048-0.01,0.145-0.029c0.367-0.071,1.422-0.258,2.855-0.416v76.326H93.159l0.003,12.645l-10.209-0.088H55.229
	c-3.345-0.001-5.918-1.036-7.748-2.153c-0.915-0.559-1.643-1.138-2.184-1.617c-0.543-0.482-0.892-0.856-1.083-1.04
	c-0.238-0.226-0.461-0.466-0.673-0.717l1.598,2.121l3.326,2.311l3.731,1.097l4.623,0.444l26.565-0.081l10.14,0.041l0.039-12.64
	l58.685-0.042l0.123,13.046l12.734,0.081l6.935,0.041l33.054-0.081v-24.78l0.081-33.541l-5.07-0.163L196.861,75.563z
	 M204.76,148.289l-52.074,0.036l-0.155-13.087h-6.656l-0.016-76.402c1.06-0.098,2.276-0.17,3.566-0.17
	c3.497-0.005,7.505,0.54,10.234,2.472c3.034,2.141,5.792,4.351,7.833,6.73c2.044,2.381,3.366,4.915,3.587,7.73l0.028,0.343h25.331
	l3.319,14.579l4.983,0.002v8.376L204.76,148.289z"/>
<polygon points="284.172,80.053 284.172,91.107 299.88,106.816 299.88,111.067 301.856,111.067 301.856,110.322 300.625,110.322 
	300.625,106.507 284.917,90.799 284.917,80.053 "/>
<polygon points="381.306,74.752 381.306,90.901 364.408,90.901 364.408,110.507 365.153,110.507 365.153,91.646 382.051,91.646 
	382.051,74.752 "/>
<polygon points="396.694,134.872 396.694,148.265 390.879,148.265 390.879,149.01 397.44,149.01 397.44,134.872 396.695,134.872 "/>
<polygon points="415.659,148.306 407.376,148.306 407.376,136.476 406.632,136.476 406.632,149.051 415.659,149.051 "/>
<polygon points="403.419,164.886 403.359,157.321 406.728,157.369 406.771,154.838 406.026,154.826 405.995,156.613 
	402.609,156.564 402.674,164.891 "/>
<polygon points="457.281,185.203 457.301,194.188 423.084,194.127 423.084,182.766 422.339,182.766 422.339,194.87 458.047,194.934 
	458.026,185.201 457.282,185.203 "/>
<polygon points="476.784,48.532 479.401,49.534 479.401,61.513 489.563,61.513 498.637,70.273 498.637,77.981 499.382,77.981 
	499.382,69.957 489.862,60.768 480.146,60.768 480.146,49.022 477.051,47.836 "/>
<polygon points="448.052,92.276 455.038,92.276 455.038,96.67 448.239,96.67 448.239,97.416 455.783,97.416 455.783,91.532 
	448.052,91.532 "/>
<polygon points="455.147,97.307 471.927,114.086 496.906,114.086 496.906,113.341 472.234,113.341 455.674,96.781 "/>
<polyline points="485.813,154.397 485.813,197.728 486.558,197.728 486.558,154.397 "/>
<polyline points="529.014,154.758 529.014,188.501 529.759,188.501 529.759,154.758 "/>
<polygon points="541.697,78.042 541.697,70.911 550.937,61.673 561.999,61.673 561.999,44.47 561.254,44.47 561.254,60.928 
	550.627,60.928 540.952,70.603 540.952,78.042 "/>
<polygon points="543.568,91.004 561.355,91.004 569.049,83.311 595.821,83.311 595.821,82.565 568.739,82.565 561.046,90.259 
	543.568,90.259 "/>
<polygon points="571.512,110.828 571.512,100.942 575.998,100.942 575.998,95.172 592.616,95.172 592.616,94.427 575.253,94.427 
	575.253,100.197 570.767,100.197 570.767,110.828 "/>
<polyline points="577.498,95.12 577.498,110.696 578.243,110.696 578.243,95.12 "/>
<polygon points="592.692,124.221 583.373,124.221 583.373,115.972 582.628,115.972 582.628,124.965 592.692,124.965 "/>
<polygon points="562.482,143.604 562.482,143.976 568.626,143.976 568.626,138.102 562.11,138.102 562.11,143.976 562.482,143.976 
	562.482,143.604 562.854,143.604 562.854,138.847 567.881,138.847 567.881,143.232 562.482,143.232 562.482,143.604 
	562.854,143.604 "/>
<polygon points="586.205,143.925 586.205,144.297 592.027,144.297 592.027,138.421 585.833,138.421 585.833,144.297 
	586.205,144.297 586.205,143.925 586.577,143.925 586.577,139.167 591.282,139.167 591.282,143.553 586.205,143.553 
	586.205,143.925 586.577,143.925 "/>
<polygon points="474.464,97.531 474.464,97.903 480.994,97.903 480.994,91.717 474.092,91.717 474.092,97.903 474.464,97.903 
	474.464,97.531 474.836,97.531 474.836,92.462 480.249,92.462 480.249,97.159 474.464,97.159 474.464,97.531 474.836,97.531 "/>
<polygon points="480.924,97.574 480.924,97.946 493.466,97.946 493.466,90.516 480.552,90.516 480.552,97.946 480.924,97.946 
	480.924,97.574 481.295,97.574 481.295,91.261 492.721,91.261 492.721,97.202 480.924,97.202 480.924,97.574 481.295,97.574 "/>
<polygon points="497.298,97.211 493.614,97.211 493.614,93.814 497.298,93.814 497.298,93.069 492.869,93.069 492.869,97.956 
	497.298,97.956 "/>
<line x1="152.131" y1="149.08" x2="152.131" y2="148.335"/>
<polyline points="348.287,110.958 348.287,66.847 347.542,66.847 347.542,110.958 "/>
<polyline points="458.435,154.514 458.435,185.09 459.179,185.09 459.179,154.514 "/>
<line fill="#FFFFFF" x1="442.256" y1="148.863" x2="438.894" y2="147.804"/>
<line fill="#FFFFFF" x1="497.442" y1="88.34" x2="496.384" y2="84.977"/>
<line fill="#FFFFFF" x1="497.442" y1="81.22" x2="496.384" y2="84.582"/>
<polyline points="415.938,136.754 415.938,88.658 415.193,88.658 415.193,136.754 "/>
<polyline points="430.274,88.533 430.061,148.736 430.806,148.739 431.02,88.536 "/>
<polygon points="364.614,174.979 371.349,175.012 396.926,202.383 415.61,202.383 415.61,201.638 397.25,201.638 371.674,174.269 
	364.618,174.233 364.615,174.979 "/>
<polygon points="218.133,154.747 218.133,177.561 237.792,177.561 237.792,154.747 237.047,154.747 237.047,176.815 
	218.878,176.815 218.878,154.747 "/>
<rect x="218.506" y="168.8" width="18.593" height="0.745"/>
<rect x="226.469" y="154.747" width="0.745" height="14.426"/>
<polygon points="226.841,159.235 226.841,159.606 233.946,159.606 233.946,154.374 226.469,154.374 226.469,159.606 
	226.841,159.606 226.841,159.235 227.213,159.235 227.213,155.119 233.201,155.119 233.201,158.863 226.841,158.863 
	226.841,159.235 227.213,159.235 "/>
<path fill="#FFFFFF" d="M263.577,154.278l-3.36,1.068L263.577,154.278z"/>
<path fill="#FFFFFF" d="M256.457,154.296l3.365,1.052L256.457,154.296z"/>
<path fill="#FFFFFF" d="M301.528,189.678l-1.06-3.362L301.528,189.678z"/>
<polygon points="390.471,79.08 390.471,112.477 386.276,112.477 386.276,118.933 365.202,118.933 365.202,119.678 387.017,119.678 
	387.017,113.222 391.21,113.222 391.21,79.08 "/>
<polygon points="444.028,88.881 474.023,88.881 474.023,92.089 474.769,92.089 474.769,88.136 444.028,88.136 "/>
<polygon fill="#B3D7ED" points="233.201,158.863 227.214,158.863 227.214,155.177 233.201,155.17 "/>
<polygon fill="#B3D7ED" points="237.047,168.8 227.213,168.8 227.213,159.607 233.945,159.607 233.945,154.839 237.047,154.747 "/>
<rect x="240.336" y="169.638" fill="#B3D7ED" width="18.169" height="7.27"/>
<path d="M293.147,157.052l-2.381-1.945h0.245l2.241,1.816L293.147,157.052z M296.214,159.558l-0.082-0.068l0.067,0.002
	L296.214,159.558 M300.696,182.21h-0.11l0.266-18.865l-1.652-1.35l0.12-0.148l1.562,1.268l-0.053,10.881L300.696,182.21
	 M300.632,186.174l-0.05-0.031c-0.018,0.003-0.034,0.007-0.051,0.012l0.001-0.073c0.017,0.004,0.033,0.008,0.05,0.011l0.052-0.032
	L300.632,186.174 M250.956,212.821l-1.535-0.013l1.535,0.004V212.821 M278.515,222.229l-8.011-0.088h8.011V222.229 M284.534,226.513
	l-0.426-0.114v-35.096h16.35l0.018-1.277h0.095l-0.02,1.29h-16.017V226.513 M269.512,227.446v-5.306h0.588l-0.092,5.304
	L269.512,227.446"/>
<path fill="#98A9B4" d="M218.878,160.795h-0.635l-0.009-5.608l0.644-0.001V160.795z M218.25,164.469v-0.093
	c0.027,0.001,0.059,0.002,0.096,0.003l-0.01,0.011l0.036,0.033l-0.037,0.033l0.009,0.01
	C218.308,164.467,218.275,164.468,218.25,164.469 M218.878,164.503c-0.01-0.001-0.02-0.003-0.03-0.005l-0.059-0.074l0.061-0.077
	c0.009-0.002,0.018-0.004,0.028-0.005V164.503 M237.792,177.561h-19.522l-0.015-9.511h0.623v0.751h-0.373v0.745h0.373l0,7.459
	l18.263,0.016l-0.093-7.475h0.052v-0.745h-0.052v-13.635l0.745-0.001V177.561"/>
<polygon fill="#98A9B4" points="237.099,169.546 237.047,169.546 218.878,169.546 218.506,169.546 218.506,168.801 218.878,168.801 
	226.468,168.801 226.468,169.174 227.213,169.174 227.213,168.801 237.047,168.801 237.099,168.801 "/>
<polygon fill="#98A9B4" points="227.213,169.173 226.468,169.173 226.468,168.801 226.468,155.177 226.468,159.606 226.841,159.606 
	227.213,159.606 227.213,168.801 "/>
<polygon fill="#98A9B4" points="233.945,159.607 227.213,159.607 226.84,159.607 226.468,159.607 226.468,155.178 227.213,155.177 
	227.213,158.862 233.2,158.862 233.2,155.169 233.945,155.169 "/>
<polyline points="218.506,169.638 237.099,169.638 237.099,168.893 218.506,168.893 "/>
<polyline points="226.468,154.839 226.468,169.267 227.213,169.267 227.213,154.839 "/>
<polygon points="226.841,159.327 226.841,159.699 233.946,159.699 233.946,154.466 226.469,154.466 226.469,159.699 
	226.841,159.699 226.841,159.327 227.213,159.327 227.213,155.211 233.201,155.211 233.201,158.955 226.841,158.955 
	226.841,159.327 227.213,159.327 "/>
<polygon points="268.381,103.496 273.036,103.496 283.877,114.338 283.877,121.231 298.763,136.116 302.109,136.116 
	302.109,135.371 299.07,135.371 284.623,120.922 284.623,114.03 273.345,102.751 268.381,102.751 "/>
<line fill="none" stroke="#020202" stroke-width="0.75" stroke-miterlimit="10" x1="463.607" y1="148.27" x2="463.555" y2="105.18"/>
<polygon fill="#B3D7ED" points="301.475,163.082 299.822,161.73 299.822,161.731 296.838,159.294 296.819,159.279 291.389,154.843 
	264.549,154.873 261.079,154.869 261.084,154.861 260.917,154.861 260.922,154.868 257.094,154.864 237.792,154.992 
	237.375,177.177 218.5,177.271 218.5,212.82 250.611,213.177 250.69,224.793 250.66,228.03 269.805,228.03 269.805,222.361 
	270.099,222.361 270.663,222.36 271.511,222.368 277.9,222.54 278.02,223.26 278.14,224.13 278.2,225.51 284.59,226.92 
	284.607,191.819 301.01,191.793 301.099,189.761 301.098,189.761 301.153,185.891 301.154,185.818 301.209,181.947 "/>
<polygon points="301.122,180.899 301.122,180.527 285.144,180.527 285.144,175.18 287.657,175.18 300.75,175.18 300.75,180.899 
	301.122,180.899 301.122,180.527 301.122,180.899 301.494,180.899 301.494,174.435 287.657,174.435 284.398,174.435 
	284.398,181.271 301.494,181.271 301.494,180.899 "/>
<rect fill="none" width="636" height="285.333"/>
<text transform="matrix(1 0 0 1 487.3682 227.4473)" font-family="Montserrat" font-size="10.9855">DCOTA 2nd Floor</text>
<text transform="matrix(1 0 0 1 309.0449 152.7861)" fill="#000100" font-family="Montserrat" font-size="6.7761">ATRIUM B</text>
<text transform="matrix(1 0 0 1 96.5957 167.9941)" fill="#000100" font-family="Montserrat" font-size="6.7761">ATRIUM A</text>
<text transform="matrix(1 0 0 1 500.1787 152.6436)" fill="#000100" font-family="Montserrat" font-size="6.7761">ATRIUM C</text>
<g>
	<defs>
		<rect id="SVGID_33_" width="636" height="285.333"/>
	</defs>
	<clipPath id="SVGID_34_">
		<use xlink:href="#SVGID_33_"  overflow="visible"/>
	</clipPath>
	<rect x="526.45" y="94.998" clip-path="url(#SVGID_34_)" width="12.071" height="12.072"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M531.024,95.929c-0.038-0.05-0.108-0.081-0.186-0.081
		c-0.076,0-0.147,0.031-0.186,0.081l-1.012,1.324c-0.039,0.049-0.039,0.111,0,0.161c0.037,0.05,0.108,0.081,0.186,0.081h0.484v1.224
		h1.073v-1.224h0.467c0.077,0,0.147-0.031,0.186-0.081c0.039-0.05,0.039-0.112,0-0.161L531.024,95.929z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M533.947,98.639c0.037,0.05,0.108,0.081,0.186,0.081s0.147-0.031,0.186-0.081
		l1.012-1.323c0.039-0.05,0.039-0.112,0-0.162c-0.037-0.05-0.108-0.081-0.186-0.081h-0.484v-1.224h-1.074v1.224h-0.466
		c-0.077,0-0.148,0.031-0.187,0.081c-0.039,0.05-0.039,0.112,0,0.161L533.947,98.639z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M536.449,99.227h-7.927c-0.675,0-1.222,0.547-1.222,1.223v4.546
		c0,0.675,0.547,1.223,1.222,1.223h7.927c0.675,0,1.223-0.548,1.223-1.223v-4.546C537.672,99.774,537.124,99.227,536.449,99.227
		 M536.449,99.694c0.415,0,0.755,0.339,0.755,0.756v4.546c0,0.417-0.34,0.756-0.755,0.756h-7.927c-0.417,0-0.755-0.339-0.755-0.756
		v-4.546c0-0.417,0.338-0.756,0.755-0.756H536.449z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M531.592,101.129c0-0.563-0.367-0.843-0.818-0.843
		c-0.452,0-0.819,0.28-0.819,0.843C529.954,102.25,531.592,102.251,531.592,101.129"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M531.437,102.275c-0.123-0.052-0.307-0.083-0.503-0.094h-0.321
		c-0.197,0.011-0.381,0.042-0.503,0.094c-0.719,0.301-0.586,1.255-0.586,2.003c0,0.173,0.112,0.323,0.258,0.344
		c0.012,0.002,0.022,0.003,0.033,0.003c0.159,0,0.295-0.155,0.295-0.347l0.144,0.981c0,0.138,0.079,0.251,0.18,0.251h0.68
		c0.101,0,0.182-0.113,0.182-0.251l0.143-0.981c0,0.173,0.113,0.323,0.258,0.344c0.011,0.002,0.023,0.003,0.033,0.003
		c0.158,0,0.294-0.155,0.294-0.347C532.021,103.515,532.155,102.577,531.437,102.275"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M535.018,101.129c0-0.563-0.367-0.843-0.819-0.843s-0.818,0.28-0.818,0.843
		C533.38,102.25,535.018,102.251,535.018,101.129"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M534.862,102.275c-0.123-0.052-0.308-0.083-0.503-0.094h-0.321
		c-0.197,0.011-0.381,0.042-0.503,0.094c-0.719,0.301-0.586,1.255-0.586,2.003c0,0.173,0.112,0.323,0.258,0.344
		c0.011,0.002,0.022,0.003,0.033,0.003c0.158,0,0.295-0.155,0.295-0.347l0.143,0.981c0,0.138,0.081,0.251,0.181,0.251h0.681
		c0.099,0,0.18-0.113,0.18-0.251l0.144-0.981c0,0.173,0.113,0.323,0.258,0.344c0.012,0.002,0.022,0.003,0.033,0.003
		c0.158,0,0.295-0.155,0.295-0.347C535.448,103.515,535.581,102.577,534.862,102.275"/>
	<rect x="526.45" y="119.7" clip-path="url(#SVGID_34_)" width="12.071" height="12.072"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M531.024,120.631c-0.038-0.05-0.108-0.081-0.186-0.081
		c-0.076,0-0.147,0.031-0.186,0.081l-1.012,1.324c-0.039,0.049-0.039,0.111,0,0.161c0.037,0.05,0.108,0.081,0.186,0.081h0.484v1.224
		h1.073v-1.224h0.467c0.077,0,0.147-0.031,0.186-0.081c0.039-0.05,0.039-0.112,0-0.161L531.024,120.631z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M533.947,123.341c0.037,0.05,0.108,0.081,0.186,0.081s0.147-0.031,0.186-0.081
		l1.012-1.323c0.039-0.05,0.039-0.112,0-0.162c-0.037-0.05-0.108-0.081-0.186-0.081h-0.484v-1.224h-1.074v1.224h-0.466
		c-0.077,0-0.148,0.031-0.187,0.081c-0.039,0.05-0.039,0.112,0,0.161L533.947,123.341z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M536.449,123.93h-7.927c-0.675,0-1.222,0.547-1.222,1.223v4.546
		c0,0.675,0.547,1.223,1.222,1.223h7.927c0.675,0,1.223-0.548,1.223-1.223v-4.546C537.672,124.477,537.124,123.93,536.449,123.93
		 M536.449,124.396c0.415,0,0.755,0.339,0.755,0.756v4.546c0,0.417-0.34,0.756-0.755,0.756h-7.927c-0.417,0-0.755-0.339-0.755-0.756
		v-4.546c0-0.417,0.338-0.756,0.755-0.756H536.449z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M531.592,125.832c0-0.563-0.367-0.843-0.818-0.843
		c-0.452,0-0.819,0.28-0.819,0.843C529.954,126.953,531.592,126.954,531.592,125.832"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M531.437,126.977c-0.123-0.052-0.307-0.083-0.503-0.094h-0.321
		c-0.197,0.011-0.381,0.042-0.503,0.094c-0.719,0.301-0.586,1.255-0.586,2.003c0,0.173,0.112,0.324,0.258,0.344
		c0.012,0.002,0.022,0.003,0.033,0.003c0.159,0,0.295-0.155,0.295-0.347l0.144,0.981c0,0.138,0.079,0.251,0.18,0.251h0.68
		c0.101,0,0.182-0.113,0.182-0.251l0.143-0.981c0,0.173,0.113,0.324,0.258,0.344c0.011,0.002,0.023,0.003,0.033,0.003
		c0.158,0,0.294-0.155,0.294-0.347C532.021,128.217,532.155,127.279,531.437,126.977"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M535.018,125.832c0-0.563-0.367-0.843-0.819-0.843s-0.818,0.28-0.818,0.843
		C533.38,126.953,535.018,126.954,535.018,125.832"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M534.862,126.977c-0.123-0.052-0.308-0.083-0.503-0.094h-0.321
		c-0.197,0.011-0.381,0.042-0.503,0.094c-0.719,0.301-0.586,1.255-0.586,2.003c0,0.173,0.112,0.324,0.258,0.344
		c0.011,0.002,0.022,0.003,0.033,0.003c0.158,0,0.295-0.155,0.295-0.347l0.143,0.981c0,0.138,0.081,0.251,0.181,0.251h0.681
		c0.099,0,0.18-0.113,0.18-0.251l0.144-0.981c0,0.173,0.113,0.324,0.258,0.344c0.012,0.002,0.022,0.003,0.033,0.003
		c0.158,0,0.295-0.155,0.295-0.347C535.448,128.217,535.581,127.279,534.862,126.977"/>
	<rect x="346.282" y="130.964" clip-path="url(#SVGID_34_)" width="12.071" height="12.072"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M350.856,131.895c-0.038-0.05-0.109-0.081-0.187-0.081
		c-0.075,0-0.146,0.031-0.185,0.081l-1.012,1.324c-0.039,0.049-0.039,0.111,0,0.161c0.037,0.05,0.107,0.081,0.185,0.081h0.485v1.224
		h1.074v-1.224h0.466c0.077,0,0.147-0.031,0.185-0.081c0.039-0.05,0.039-0.112,0-0.161L350.856,131.895z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M353.778,134.605c0.038,0.05,0.109,0.081,0.187,0.081
		c0.076,0,0.146-0.031,0.185-0.081l1.012-1.323c0.039-0.05,0.039-0.112,0-0.162c-0.037-0.05-0.107-0.081-0.185-0.081h-0.485v-1.224
		h-1.073v1.224h-0.467c-0.077,0-0.147,0.031-0.186,0.081c-0.039,0.05-0.039,0.112,0,0.161L353.778,134.605z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M356.28,135.193h-7.926c-0.675,0-1.223,0.547-1.223,1.223v4.546
		c0,0.675,0.548,1.223,1.223,1.223h7.926c0.675,0,1.223-0.548,1.223-1.223v-4.546C357.503,135.741,356.955,135.193,356.28,135.193
		 M356.28,135.661c0.417,0,0.755,0.339,0.755,0.756v4.546c0,0.417-0.338,0.756-0.755,0.756h-7.926c-0.417,0-0.755-0.339-0.755-0.756
		v-4.546c0-0.417,0.338-0.756,0.755-0.756H356.28z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M351.424,137.096c0-0.563-0.367-0.843-0.819-0.843s-0.818,0.28-0.818,0.843
		C349.786,138.216,351.424,138.217,351.424,137.096"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M351.269,138.241c-0.123-0.052-0.308-0.083-0.503-0.094h-0.321
		c-0.197,0.011-0.381,0.042-0.503,0.094c-0.719,0.301-0.586,1.255-0.586,2.003c0,0.173,0.111,0.324,0.258,0.344
		c0.011,0.002,0.021,0.003,0.034,0.003c0.157,0,0.294-0.155,0.294-0.347l0.143,0.981c0,0.138,0.08,0.251,0.18,0.251h0.681
		c0.1,0,0.181-0.113,0.181-0.251l0.144-0.981c0,0.173,0.112,0.324,0.258,0.344c0.011,0.002,0.022,0.003,0.033,0.003
		c0.157,0,0.294-0.155,0.294-0.347C351.854,139.481,351.987,138.543,351.269,138.241"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M354.849,137.096c0-0.563-0.366-0.843-0.818-0.843s-0.819,0.28-0.819,0.843
		C353.211,138.216,354.849,138.217,354.849,137.096"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M354.693,138.241c-0.123-0.052-0.307-0.083-0.503-0.094h-0.32
		c-0.197,0.011-0.382,0.042-0.503,0.094c-0.72,0.301-0.586,1.255-0.586,2.003c0,0.173,0.111,0.324,0.258,0.344
		c0.011,0.002,0.021,0.003,0.034,0.003c0.157,0,0.294-0.155,0.294-0.347l0.143,0.981c0,0.138,0.081,0.251,0.18,0.251h0.682
		c0.099,0,0.18-0.113,0.18-0.251l0.143-0.981c0,0.173,0.113,0.324,0.259,0.344c0.012,0.002,0.021,0.003,0.032,0.003
		c0.158,0,0.295-0.155,0.295-0.347C355.279,139.481,355.413,138.543,354.693,138.241"/>
	<rect x="346.282" y="155.666" clip-path="url(#SVGID_34_)" width="12.071" height="12.072"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M350.856,156.598c-0.038-0.05-0.109-0.081-0.187-0.081
		c-0.075,0-0.146,0.031-0.185,0.081l-1.012,1.324c-0.039,0.049-0.039,0.11,0,0.161c0.037,0.05,0.107,0.081,0.185,0.081h0.485v1.224
		h1.074v-1.224h0.466c0.077,0,0.147-0.031,0.185-0.081c0.039-0.051,0.039-0.112,0-0.161L350.856,156.598z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M353.778,159.308c0.038,0.05,0.109,0.081,0.187,0.081
		c0.076,0,0.146-0.031,0.185-0.081l1.012-1.323c0.039-0.05,0.039-0.112,0-0.162c-0.037-0.05-0.107-0.081-0.185-0.081h-0.485v-1.224
		h-1.073v1.224h-0.467c-0.077,0-0.147,0.031-0.186,0.081c-0.039,0.05-0.039,0.112,0,0.161L353.778,159.308z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M356.28,159.896h-7.926c-0.675,0-1.223,0.548-1.223,1.224v4.546
		c0,0.675,0.548,1.223,1.223,1.223h7.926c0.675,0,1.223-0.548,1.223-1.223v-4.546C357.503,160.443,356.955,159.896,356.28,159.896
		 M356.28,160.363c0.417,0,0.755,0.339,0.755,0.756v4.546c0,0.416-0.338,0.756-0.755,0.756h-7.926c-0.417,0-0.755-0.34-0.755-0.756
		v-4.546c0-0.417,0.338-0.756,0.755-0.756H356.28z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M351.424,161.798c0-0.563-0.367-0.843-0.819-0.843s-0.818,0.28-0.818,0.843
		C349.786,162.919,351.424,162.92,351.424,161.798"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M351.269,162.943c-0.123-0.052-0.308-0.083-0.503-0.094h-0.321
		c-0.197,0.011-0.381,0.042-0.503,0.094c-0.719,0.301-0.586,1.255-0.586,2.003c0,0.173,0.111,0.323,0.258,0.344
		c0.011,0.002,0.021,0.003,0.034,0.003c0.157,0,0.294-0.154,0.294-0.347l0.143,0.981c0,0.138,0.08,0.251,0.18,0.251h0.681
		c0.1,0,0.181-0.113,0.181-0.251l0.144-0.981c0,0.173,0.112,0.323,0.258,0.344c0.011,0.002,0.022,0.003,0.033,0.003
		c0.157,0,0.294-0.154,0.294-0.347C351.854,164.184,351.987,163.245,351.269,162.943"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M354.849,161.798c0-0.563-0.366-0.843-0.818-0.843s-0.819,0.28-0.819,0.843
		C353.211,162.919,354.849,162.92,354.849,161.798"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M354.693,162.943c-0.123-0.052-0.307-0.083-0.503-0.094h-0.32
		c-0.197,0.011-0.382,0.042-0.503,0.094c-0.72,0.301-0.586,1.255-0.586,2.003c0,0.173,0.111,0.323,0.258,0.344
		c0.011,0.002,0.021,0.003,0.034,0.003c0.157,0,0.294-0.154,0.294-0.347l0.143,0.981c0,0.138,0.081,0.251,0.18,0.251h0.682
		c0.099,0,0.18-0.113,0.18-0.251l0.143-0.981c0,0.173,0.113,0.323,0.259,0.344c0.012,0.002,0.021,0.003,0.032,0.003
		c0.158,0,0.295-0.154,0.295-0.347C355.279,164.184,355.413,163.245,354.693,162.943"/>
	<rect x="171.095" y="142.14" clip-path="url(#SVGID_34_)" width="16.462" height="17.16"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M181.821,153.968c-0.291,0-0.558,0-0.826,0c-0.23-0.002-0.323-0.103-0.28-0.33
		c0.181-0.978,0.369-1.953,0.55-2.931c0.155-0.822,0.303-1.645,0.456-2.475h-0.256c-0.07,0.356-0.139,0.718-0.209,1.079
		c-0.118,0.608-0.23,1.219-0.354,1.827c-0.025,0.12-0.078,0.241-0.146,0.345c-0.118,0.177-0.29,0.283-0.512,0.234
		c-0.226-0.048-0.35-0.215-0.39-0.429c-0.028-0.136-0.031-0.285-0.005-0.422c0.222-1.189,0.454-2.376,0.681-3.563
		c0.079-0.409,0.246-0.587,0.654-0.662c0.215-0.04,0.437-0.075,0.657-0.075c0.858-0.005,1.716,0.003,2.574,0.014
		c0.162,0.002,0.322,0.04,0.483,0.067c0.347,0.054,0.535,0.269,0.6,0.603c0.165,0.854,0.329,1.704,0.494,2.557
		c0.07,0.363,0.14,0.725,0.208,1.087c0.04,0.201,0.026,0.398-0.081,0.58c-0.171,0.294-0.513,0.354-0.743,0.104
		c-0.111-0.121-0.2-0.29-0.233-0.451c-0.19-0.917-0.361-1.838-0.539-2.758c-0.008-0.046-0.019-0.091-0.03-0.14h-0.254
		c0.089,0.483,0.178,0.959,0.267,1.433c0.245,1.313,0.492,2.627,0.737,3.941c0.05,0.263-0.037,0.363-0.304,0.364
		c-0.257,0-0.516,0-0.798,0v0.191c0,1.047,0.003,2.095-0.003,3.142c-0.001,0.128-0.032,0.265-0.084,0.379
		c-0.077,0.174-0.225,0.276-0.424,0.279c-0.199,0.003-0.352-0.097-0.431-0.269c-0.056-0.125-0.088-0.273-0.088-0.409
		c-0.008-1.038-0.005-2.075-0.005-3.113v-0.186h-0.333v0.183c0,1.037,0.004,2.074-0.004,3.111c0,0.133-0.027,0.273-0.079,0.396
		c-0.078,0.18-0.229,0.286-0.436,0.286c-0.206,0-0.354-0.108-0.435-0.288c-0.05-0.11-0.075-0.242-0.076-0.366
		c-0.005-1.041-0.003-2.084-0.003-3.127V153.968z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M175.315,152.391h-0.194v0.192c0,1.548,0,3.096,0,4.644
		c0,0.348-0.192,0.62-0.484,0.698c-0.338,0.088-0.688-0.125-0.772-0.478c-0.022-0.096-0.027-0.198-0.027-0.298
		c-0.002-2.99-0.002-5.981-0.003-8.973v-0.208h-0.226v0.186c0,1.176,0,2.35,0.001,3.523c0,0.22-0.054,0.417-0.209,0.578
		c-0.226,0.23-0.549,0.228-0.768-0.009c-0.132-0.142-0.198-0.312-0.198-0.504c0-1.279-0.009-2.559,0.004-3.838
		c0.006-0.718,0.612-1.339,1.327-1.354c0.97-0.018,1.939-0.018,2.907,0c0.708,0.015,1.317,0.634,1.324,1.343
		c0.013,1.284,0.005,2.57,0.005,3.855c0,0.025-0.003,0.053-0.007,0.079c-0.043,0.342-0.298,0.6-0.588,0.596
		c-0.288-0.003-0.54-0.27-0.575-0.61c-0.007-0.062-0.005-0.126-0.005-0.188v-3.46v-0.195H176.6v0.212
		c0,3.001-0.001,6.003-0.003,9.004c0,0.093-0.006,0.191-0.029,0.283c-0.078,0.299-0.364,0.505-0.658,0.481
		c-0.31-0.024-0.564-0.29-0.592-0.618c-0.005-0.06-0.003-0.117-0.003-0.175v-4.566V152.391z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M183.02,146.14c-0.733,0-1.325-0.595-1.323-1.329
		c0.003-0.73,0.602-1.323,1.334-1.318c0.722,0.002,1.313,0.598,1.315,1.321C184.348,145.545,183.752,146.14,183.02,146.14"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M173.894,144.798c0.003-0.734,0.596-1.32,1.333-1.317
		c0.731,0.005,1.32,0.601,1.314,1.335c-0.004,0.722-0.602,1.313-1.325,1.312C174.486,146.127,173.891,145.528,173.894,144.798"/>
	<rect x="398.304" y="142.14" clip-path="url(#SVGID_34_)" width="16.462" height="17.16"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M409.029,153.968c-0.291,0-0.558,0-0.826,0
		c-0.229-0.002-0.323-0.103-0.28-0.33c0.182-0.978,0.369-1.953,0.551-2.931c0.154-0.822,0.303-1.645,0.456-2.475h-0.257
		c-0.068,0.356-0.139,0.718-0.208,1.079c-0.118,0.608-0.23,1.219-0.354,1.827c-0.025,0.12-0.078,0.241-0.146,0.345
		c-0.117,0.177-0.29,0.283-0.512,0.234c-0.226-0.048-0.35-0.215-0.39-0.429c-0.028-0.136-0.031-0.285-0.005-0.422
		c0.223-1.189,0.454-2.376,0.681-3.563c0.08-0.409,0.246-0.587,0.654-0.662c0.215-0.04,0.437-0.075,0.656-0.075
		c0.859-0.005,1.716,0.003,2.574,0.014c0.162,0.002,0.323,0.04,0.483,0.067c0.347,0.054,0.535,0.269,0.6,0.603
		c0.166,0.854,0.329,1.704,0.494,2.557c0.07,0.363,0.14,0.725,0.209,1.087c0.039,0.201,0.025,0.398-0.082,0.58
		c-0.171,0.294-0.513,0.354-0.743,0.104c-0.11-0.121-0.199-0.29-0.232-0.451c-0.19-0.917-0.361-1.838-0.539-2.758
		c-0.008-0.046-0.021-0.091-0.03-0.14h-0.254c0.089,0.483,0.179,0.959,0.267,1.433c0.245,1.313,0.492,2.627,0.738,3.941
		c0.05,0.263-0.038,0.363-0.306,0.364c-0.257,0-0.516,0-0.796,0v0.191c0,1.047,0.002,2.095-0.004,3.142
		c-0.002,0.128-0.031,0.265-0.084,0.379c-0.077,0.174-0.226,0.276-0.425,0.279s-0.352-0.097-0.431-0.269
		c-0.056-0.125-0.088-0.273-0.089-0.409c-0.007-1.038-0.004-2.075-0.004-3.113v-0.186h-0.333v0.183c0,1.037,0.005,2.074-0.004,3.111
		c0,0.133-0.027,0.273-0.079,0.396c-0.077,0.18-0.229,0.286-0.437,0.286c-0.206,0-0.354-0.108-0.435-0.288
		c-0.05-0.11-0.075-0.242-0.076-0.366c-0.005-1.041-0.003-2.084-0.003-3.127V153.968z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M402.523,152.391h-0.194v0.192c0,1.548,0,3.096,0,4.644
		c0,0.348-0.191,0.62-0.482,0.698c-0.34,0.088-0.689-0.125-0.772-0.478c-0.022-0.096-0.027-0.198-0.027-0.298
		c-0.003-2.99-0.003-5.981-0.004-8.973v-0.208h-0.226v0.186c0,1.176,0,2.35,0.002,3.523c0,0.22-0.054,0.417-0.209,0.578
		c-0.226,0.23-0.549,0.228-0.769-0.009c-0.133-0.142-0.198-0.312-0.198-0.504c0-1.279-0.009-2.559,0.004-3.838
		c0.006-0.718,0.612-1.339,1.328-1.354c0.969-0.018,1.938-0.018,2.907,0c0.708,0.015,1.315,0.634,1.322,1.343
		c0.014,1.284,0.005,2.57,0.005,3.855c0,0.025-0.002,0.053-0.006,0.079c-0.044,0.342-0.299,0.6-0.589,0.596
		c-0.288-0.003-0.54-0.27-0.575-0.61c-0.006-0.062-0.005-0.126-0.005-0.188v-3.46v-0.195h-0.227v0.212
		c0,3.001-0.002,6.003-0.003,9.004c0,0.093-0.006,0.191-0.029,0.283c-0.078,0.299-0.365,0.505-0.658,0.481
		c-0.31-0.024-0.564-0.29-0.592-0.618c-0.005-0.06-0.003-0.117-0.003-0.175v-4.566V152.391z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M410.229,146.14c-0.733,0-1.324-0.595-1.323-1.329
		c0.003-0.73,0.602-1.323,1.334-1.318c0.722,0.002,1.313,0.598,1.314,1.321C411.557,145.545,410.961,146.14,410.229,146.14"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M401.103,144.798c0.003-0.734,0.597-1.32,1.333-1.317
		c0.731,0.005,1.319,0.601,1.314,1.335c-0.004,0.722-0.603,1.313-1.324,1.312C401.694,146.127,401.1,145.528,401.103,144.798"/>
	<polygon clip-path="url(#SVGID_34_)" points="528.441,78.042 528.439,78.415 543.467,78.476 543.526,102.536 552.376,111.057 
		596.851,110.942 596.856,94.398 593.319,94.398 593.539,92.496 596.446,92.496 596.446,73.673 591.576,73.428 582.666,43.931 
		534.751,43.931 534.463,46.488 531.981,46.488 531.715,34.733 508.771,34.733 508.294,47.227 505.688,47.039 505.754,44.02 
		476.836,44.02 476.526,48.053 444.251,56.244 444.327,89.136 447.741,92.177 447.492,148.997 488.162,149.042 497.558,141.208 
		497.558,78.333 512.178,78.354 528.439,78.415 528.441,78.042 528.443,77.67 512.181,77.608 496.813,77.585 496.813,140.858 
		487.893,148.297 448.239,148.253 448.488,91.844 445.071,88.801 444.997,56.823 477.228,48.643 477.525,44.765 504.992,44.765 
		504.928,47.731 509.01,48.025 509.488,35.479 530.985,35.479 531.253,47.232 535.127,47.232 535.416,44.676 582.112,44.676 
		591.016,74.146 595.701,74.382 595.701,91.75 592.875,91.75 592.484,95.143 596.111,95.143 596.105,110.2 552.677,110.312 
		544.271,102.218 544.209,77.733 528.443,77.67 	"/>
	<rect x="543.839" y="133.595" clip-path="url(#SVGID_34_)" width="51.602" height="0.75"/>
	<rect x="578.979" y="103.815" clip-path="url(#SVGID_34_)" width="16.463" height="17.16"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M589.704,115.643c-0.291,0-0.558,0-0.826,0
		c-0.229-0.002-0.323-0.103-0.279-0.33c0.181-0.978,0.368-1.954,0.55-2.931c0.154-0.822,0.303-1.645,0.456-2.475h-0.256
		c-0.069,0.357-0.14,0.718-0.208,1.079c-0.119,0.609-0.231,1.219-0.355,1.828c-0.025,0.12-0.078,0.241-0.146,0.344
		c-0.118,0.177-0.29,0.283-0.513,0.235c-0.226-0.048-0.35-0.215-0.39-0.429c-0.028-0.136-0.031-0.285-0.005-0.422
		c0.223-1.189,0.454-2.376,0.681-3.563c0.08-0.41,0.246-0.587,0.654-0.663c0.215-0.04,0.437-0.075,0.657-0.075
		c0.858-0.005,1.715,0.003,2.573,0.014c0.162,0.002,0.323,0.04,0.484,0.067c0.346,0.054,0.534,0.269,0.599,0.603
		c0.166,0.853,0.329,1.704,0.494,2.557c0.07,0.363,0.141,0.724,0.209,1.086c0.039,0.202,0.025,0.399-0.082,0.581
		c-0.171,0.293-0.513,0.354-0.743,0.104c-0.11-0.121-0.199-0.29-0.232-0.451c-0.19-0.917-0.361-1.838-0.539-2.758
		c-0.008-0.046-0.021-0.091-0.03-0.14h-0.254c0.089,0.484,0.179,0.959,0.268,1.433c0.244,1.313,0.491,2.627,0.737,3.941
		c0.05,0.263-0.038,0.364-0.306,0.365c-0.257,0-0.516,0-0.796,0v0.191c0,1.047,0.002,2.095-0.004,3.142
		c-0.001,0.128-0.031,0.264-0.083,0.379c-0.078,0.173-0.227,0.276-0.426,0.279s-0.352-0.097-0.431-0.269
		c-0.056-0.125-0.088-0.273-0.089-0.409c-0.007-1.038-0.004-2.075-0.004-3.113v-0.186h-0.333v0.183c0,1.037,0.004,2.074-0.004,3.111
		c0,0.133-0.027,0.274-0.079,0.397c-0.077,0.179-0.229,0.286-0.437,0.286c-0.206,0-0.353-0.109-0.435-0.288
		c-0.05-0.111-0.075-0.242-0.076-0.366c-0.006-1.041-0.003-2.084-0.003-3.127V115.643z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M583.198,114.065h-0.194v0.192c0,1.548,0,3.096,0,4.644
		c0,0.348-0.191,0.62-0.482,0.698c-0.34,0.088-0.689-0.125-0.772-0.477c-0.022-0.096-0.027-0.199-0.027-0.298
		c-0.002-2.99-0.002-5.982-0.003-8.973v-0.208h-0.227v0.186c0,1.175,0,2.349,0.002,3.523c0,0.22-0.054,0.417-0.209,0.578
		c-0.226,0.231-0.549,0.228-0.769-0.009c-0.132-0.141-0.198-0.311-0.198-0.503c0-1.28-0.009-2.559,0.004-3.838
		c0.006-0.718,0.612-1.339,1.328-1.354c0.969-0.017,1.939-0.017,2.907,0c0.708,0.015,1.315,0.634,1.323,1.343
		c0.013,1.284,0.005,2.57,0.005,3.855c0,0.026-0.002,0.053-0.007,0.079c-0.044,0.342-0.299,0.6-0.589,0.596
		c-0.288-0.003-0.54-0.269-0.574-0.61c-0.007-0.062-0.006-0.126-0.006-0.189v-3.46v-0.194h-0.227v0.211
		c0,3.001-0.002,6.003-0.004,9.004c0,0.093-0.005,0.191-0.028,0.283c-0.078,0.299-0.365,0.505-0.658,0.482
		c-0.31-0.025-0.564-0.29-0.592-0.619c-0.005-0.059-0.003-0.117-0.003-0.174v-4.567V114.065z"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M590.903,107.814c-0.733,0-1.324-0.595-1.323-1.329
		c0.003-0.731,0.602-1.323,1.334-1.318c0.722,0.002,1.313,0.597,1.315,1.321C592.232,107.22,591.636,107.814,590.903,107.814"/>
	<path clip-path="url(#SVGID_34_)" fill="#FFFFFF" d="M581.777,106.473c0.003-0.734,0.597-1.32,1.333-1.317
		c0.731,0.005,1.32,0.6,1.314,1.335c-0.004,0.721-0.603,1.313-1.324,1.311C582.369,107.802,581.774,107.204,581.777,106.473"/>
	
		<rect clip-path="url(#SVGID_34_)" fill="none" stroke="#FFFFFF" stroke-width="0.25" stroke-miterlimit="10" width="636" height="285.333"/>
	<path clip-path="url(#SVGID_34_)" d="M444.753,88.195h-28.841V75.18h-5.109v4.814h-19.563v-3.29l-0.283-0.069
		c-0.001,0-16.606-4.093-33.838-8.246c-8.617-2.077-17.39-4.169-24.325-5.772c-3.466-0.801-6.473-1.481-8.773-1.975
		c-0.251-0.054-0.489-0.105-0.724-0.154l0.003-0.01c-3.019-0.821-6.988-1.723-9.083-2.154c-0.309-0.085-1.775-0.45-4.274-0.45
		c-2.596,0-6.296,0.396-10.934,1.916c-4.861,1.591-8.063,4.487-10.274,7.334c-1.107,1.423-1.968,2.835-2.67,4.069
		c-0.652,1.144-1.167,2.123-1.605,2.815l-25.771-0.033l-3.586,15.663l-5.089,0.244v9.127l-45.271-0.487l0.018,50.513h85.87
		l11.734-8.779v-29.174h62.089v31.315l6.909,6.6h20.076v-13.47l8.202,0.008l1.573,1.606l14.248-0.017l0.037,11.899l0.372-0.001
		l32.372-0.075V97.032l0.06-4.979L444.753,88.195z M447.498,97.026v51.177l-31.256,0.072l-0.037-11.898l-14.678,0.018l-1.572-1.605
		l-9.262-0.01v13.472H371.66l-6.462-6.174v-31.741h-63.58v29.547l-11.237,8.406h-84.876l-0.018-49.015l45.27,0.486v-9.169
		l4.944-0.237l3.581-15.634l25.584,0.032l0.11-0.167c0.497-0.752,1.04-1.806,1.735-3.025c2.085-3.656,5.49-8.756,12.528-11.063
		c4.564-1.495,8.183-1.878,10.703-1.879c1.206,0,2.145,0.088,2.831,0.185l-0.001,0.011c0.198,0.013,1.793,0.336,3.882,0.806
		c0.632,0.143,0.933,0.174,1.606,0.368c1.579,0.37,3.289,0.791,4.841,1.213l0.003-0.009c0.242,0.06,0.494,0.12,0.759,0.177
		c8.027,1.726,24.761,5.724,39.48,9.29c7.361,1.781,14.22,3.456,19.238,4.686c2.509,0.615,4.558,1.117,5.98,1.467
		c0.931,0.229,1.586,0.39,1.932,0.475v3.451h21.054v-4.814h3.619V88.94h29.259l3.128,3.4L447.498,97.026z"/>
	
		<line clip-path="url(#SVGID_34_)" fill="none" stroke="#000000" stroke-width="0.75" stroke-miterlimit="10" x1="512.237" y1="62.908" x2="529.188" y2="62.908"/>
	
		<rect x="531.838" y="167.74" transform="matrix(0.1168 0.9932 -0.9932 0.1168 648.6612 -393.1589)" clip-path="url(#SVGID_34_)" width="27.074" height="0.749"/>
</g>
<rect x="218.125" y="175.063" width="0.75" height="37.978"/>
<path fill="none" d="M98.713,244.192c0.464-0.104,0.915-0.203,1.356-0.302l-4.569,0.813
	C96.536,244.603,97.604,244.439,98.713,244.192z"/>
<polygon fill="none" points="300.853,163.346 300.562,163.108 300.693,174.658 "/>
<path fill="none" d="M126.532,237.843l-8.006,1.886C120.834,239.19,123.443,238.577,126.532,237.843z"/>
<path fill="none" d="M176.78,225.652l-6.813,1.623l-34.322,8.389c9.473-2.276,22.427-5.416,41.195-9.985l0.021-3.473h-0.041
	L176.78,225.652z"/>
<polygon fill="none" points="269.411,227.541 269.512,227.541 269.512,222.287 269.452,222.287 "/>
<path fill="none" d="M284.012,226.476c0.033,0.008,0.062,0.016,0.095,0.023v-35.035h-0.054L284.012,226.476z"/>
<polygon fill="none" points="87.755,195.711 87.759,195.711 87.759,159.688 87.726,159.657 87.646,171.722 "/>
<polygon fill="none" points="204.887,227.54 205.031,227.54 205.02,212.796 204.968,212.796 "/>
<polygon fill="none" points="44.335,227.146 44.348,227.146 44.348,223.221 44.281,223.221 "/>
<path fill="none" d="M93.11,244.83c0.393,0,0.793-0.014,1.197-0.033l-3.393-0.08C91.626,244.786,92.354,244.83,93.11,244.83z"/>
<path fill="none" d="M411.463,227.372h4.031l-0.187-61.979l-18.718-0.008v-10.43l-25.115-0.062l-6.754,6.521v30.634h-79.869v34.64
	c0.05,0.013,0.094,0.023,0.144,0.036c4.21,1.063,10.082,2.537,16.723,4.188c13.283,3.3,29.645,7.301,41.961,10.103
	c8.205,1.866,14.635,3.203,17.092,3.437c0.793,0.077,1.564,0.112,2.313,0.112c8.559-0.001,14.199-4.733,17.462-8.673
	c1.505-1.814,2.428-4.493,2.967-6.927c0.541-2.434,0.708-4.622,0.755-5.466c0.013-0.241,0.016-0.37,0.016-0.371l0.011-0.362h27.195
	L411.463,227.372z"/>
<polygon fill="#8FC3E1" points="277.701,222.886 277.767,225.085 277.77,225.086 277.77,222.886 "/>
<path fill="#8FC3E1" d="M72.571,233.403l0.049,0.067c-0.034-0.061-0.072-0.122-0.104-0.183L72.571,233.403z"/>
<polygon fill="#8FC3E1" points="39.321,163.206 39.32,154.395 39.171,154.395 39.131,158.289 39.04,213.302 39,227.276 
	39.169,227.276 39.169,175.332 "/>
<path fill="#8FC3E1" d="M70.213,223.9h-0.114l0.058,1.511l0.121,0.705c-0.059-0.604-0.083-1.136-0.083-1.549
	C70.195,224.291,70.204,224.076,70.213,223.9z"/>
<polygon fill="#8FC3E1" points="250.075,213.556 250.269,227.641 250.274,227.641 250.214,213.556 "/>
<polygon fill="#8FC3E1" points="70.765,228.858 70.766,228.862 70.765,228.857 "/>
<polygon fill="#8FC3E1" points="82.392,154.279 40.141,154.394 82.513,154.394 "/>
<polygon fill="#8FC3E1" points="186.883,222.876 186.919,227.561 187.021,227.562 187.061,222.876 "/>
<path fill="#8FC3E1" d="M71.421,231.008l0.159,0.331c-0.13-0.317-0.236-0.625-0.343-0.934L71.421,231.008z"/>
<path d="M72.516,233.288l-0.936-1.949C71.838,231.973,72.156,232.626,72.516,233.288z"/>
<path d="M71.237,230.405l-0.472-1.543C70.892,229.355,71.052,229.873,71.237,230.405z"/>
<path d="M176.86,222.206l-0.021,3.473c-18.768,4.569-31.723,7.709-41.195,9.985l-3.68,0.899l-5.433,1.279
	c-3.088,0.734-5.697,1.348-8.006,1.886l-3.959,0.933l-11.842,2.757l-2.654,0.473c-0.442,0.099-0.892,0.198-1.356,0.302
	c-1.109,0.247-2.177,0.41-3.212,0.512l-0.598,0.106l-0.596-0.014c-0.404,0.02-0.804,0.033-1.197,0.033
	c-0.756,0-1.484-0.044-2.196-0.113l-1.736-0.041l-5.232-1.461l-4.151-2.372l-4.569-3.833l-2.605-3.539
	c0.185,0.332,0.361,0.663,0.575,1c1.072,1.688,3.247,4.452,6.56,6.81c3.311,2.354,7.767,4.296,13.355,4.295
	c1.806,0,3.727-0.202,5.765-0.656c17.539-3.906,17.806-3.827,78.423-18.584l0.284-0.07l0.02-3.389h9.281l-0.005-0.67H176.86z"/>
<polygon points="269.512,222.287 269.512,227.541 269.411,227.541 269.411,227.641 250.274,227.641 250.277,228.332 
	270.256,228.285 270.256,222.886 277.701,222.886 277.685,222.327 "/>
<polygon points="44.348,223.221 44.348,227.146 44.335,227.146 44.337,227.276 39.169,227.276 39.169,227.892 45.093,227.892 
	45.093,223.9 70.099,223.9 70.076,223.302 "/>
<path d="M70.277,226.116c0.077,0.787,0.225,1.713,0.487,2.741l-0.324-1.784L70.277,226.116z"/>
<polygon points="205.02,212.796 205.031,227.54 204.887,227.54 204.886,227.722 187.021,227.562 187.016,228.268 205.775,228.285 
	205.766,213.434 250.075,213.556 250.066,212.878 "/>
<path d="M416.24,228.116l-0.189-63.469l-18.716-0.008v-10.428l-26.16-0.063l-7.199,6.949v30.205h-62.772l0.399-28.307l-10.743-8.775
	l-74.153,0.037l-53.612-0.016l-5.573,4.491v36.902H88.504v-36.274l-5.407-4.968h-0.584l5.215,4.927l-0.002,0.337l0.033,0.03v36.023
	l70.034,0.139l0.016-24.187l-0.11-12.423l5.594-4.751l7.24-0.177h24.212h95.432l10.382,8.519l0.003,0.277l0.291,0.237l-0.16,11.313
	l0.19,16.724l-16.776,0.082v35.035c-0.033-0.008-0.062-0.016-0.095-0.023v0.231l-6.242-1.621v0.575l0.28,0.072
	c0,0.001,18.142,4.621,37.538,9.364c9.698,2.371,19.709,4.772,27.927,6.643c8.222,1.869,14.625,3.205,17.185,3.452
	c0.818,0.078,1.611,0.115,2.385,0.115c8.854,0,14.706-4.912,18.036-8.943c1.861-2.26,2.816-5.553,3.334-8.288
	c0.392-2.086,0.519-3.84,0.557-4.566h25.729l-0.025,4.606H416.24z M384.294,222.764l-0.011,0.362c0,0.001-0.003,0.13-0.016,0.371
	c-0.047,0.844-0.214,3.032-0.755,5.466c-0.539,2.434-1.462,5.112-2.967,6.927c-3.263,3.939-8.903,8.672-17.462,8.673
	c-0.748,0-1.52-0.035-2.313-0.112c-2.457-0.233-8.887-1.57-17.092-3.437c-12.316-2.802-28.678-6.803-41.961-10.103
	c-6.641-1.65-12.513-3.125-16.723-4.188c-0.05-0.013-0.094-0.023-0.144-0.036v-34.64h79.869v-30.634l6.754-6.521l25.115,0.062v10.43
	l18.718,0.008l0.187,61.979h-4.031l0.026-4.608H384.294z"/>
<polygon points="40.141,154.394 39.32,154.394 39.32,154.395 39.78,154.395 "/>
<polygon points="204.887,227.54 187.766,227.523 187.812,222.131 176.861,222.131 176.86,222.206 186.878,222.206 186.883,222.876 
	187.061,222.876 187.021,227.562 204.886,227.722 "/>
<polygon points="284.106,191.303 284.106,191.464 300.883,191.382 300.693,174.658 300.458,191.303 "/>
<path d="M284.012,226.476c-1.642-0.415-3.004-0.761-3.976-1.006c-0.715-0.182-1.229-0.313-1.521-0.387v-2.942h-9.003v0.146
	l8.173,0.04l0.017,0.559h0.068v2.2l6.242,1.621V226.476z"/>
<polygon points="269.411,227.541 251.019,227.585 250.956,212.812 205.02,212.687 205.02,212.796 250.066,212.878 250.075,213.556 
	250.214,213.556 250.274,227.641 269.411,227.641 "/>
<polygon points="44.335,227.146 39.914,227.146 39.914,175.336 40.066,163.21 40.066,155.139 82.807,155.139 87.726,159.657 
	87.728,159.32 82.513,154.394 40.141,154.394 39.78,154.395 39.32,154.395 39.321,163.206 39.169,175.332 39.169,227.276 
	44.337,227.276 "/>
<path d="M94.903,244.811l0.598-0.106c-0.403,0.04-0.802,0.072-1.194,0.093L94.903,244.811z"/>
<path d="M102.724,243.418l11.842-2.757l3.959-0.933c-7.229,1.684-11.533,2.623-18.456,4.162L102.724,243.418z"/>
<path d="M131.965,236.563l3.68-0.899c-3.466,0.833-6.465,1.55-9.113,2.179L131.965,236.563z"/>
<path d="M79.795,240.843l4.151,2.372l5.232,1.461l1.736,0.041c-4.389-0.426-7.96-2.079-10.728-4.044
	c-3.212-2.284-5.336-4.985-6.362-6.601c-2.543-4.002-2.885-7.771-2.885-9.505c0-0.295,0.01-0.521,0.021-0.688h17.444v-27.498h69.862
	v-37.292l5.091-4.102l53.35,0.016l73.888-0.036l9.967,8.142l-0.003-0.277l-10.382-8.519h-95.432h-24.212l-7.24,0.177l-5.594,4.751
	l0.11,12.423l-0.016,24.187l-70.034-0.139v0.391h-0.1v27.032H70.72v0.021H44.348v0.065l25.728,0.081l0.023,0.599h0.114
	c-0.009,0.176-0.018,0.391-0.018,0.667c0,0.413,0.024,0.944,0.083,1.549l0.164,0.957l0.324,1.784c0,0.002,0.001,0.003,0.001,0.005
	l0.472,1.543c0.107,0.309,0.213,0.616,0.343,0.934l0.936,1.949c0.033,0.061,0.071,0.122,0.104,0.183l2.605,3.539L79.795,240.843z"/>
<polygon points="218.133,154.839 218.133,177.653 237.792,177.653 237.792,154.839 237.047,154.839 237.047,176.908 
	218.878,176.908 218.878,154.839 "/>
<text transform="matrix(1 0 0 1 43.7085 206.3447)" font-family="Montserrat" font-size="5.88">A-200</text>
<text transform="matrix(1 0 0 1 42.7085 187.0771)"><tspan x="0" y="0" font-family="Montserrat" font-size="5.8846">Intelepeer </tspan><tspan x="0" y="7.063" font-family="Montserrat" font-size="5.8846">Cloud</tspan></text>
<text transform="matrix(1 0 0 1 118.5254 222.1299)" font-family="Montserrat" font-size="5.88">A-220</text>
<text transform="matrix(1 0 0 1 118.0977 212.2178)" font-family="Montserrat" font-size="5.8846">Paisly</text>
<text transform="matrix(1 0 0 1 75.1807 100.4419)" font-family="Montserrat" font-size="5.8846">Nearpod</text>
<text transform="matrix(1 0 0 1 79.8281 109.0034)" font-family="Montserrat" font-size="5.88">A-290</text>
<g>
	<rect x="96.93" y="173.845" fill="#8FC3E1" width="52.362" height="18.063"/>
	<g>
		<polyline points="96.596,173.533 96.596,192.241 97.263,192.241 97.263,173.511 		"/>
		<polyline points="149.562,173.511 96.596,173.511 96.596,174.178 149.625,174.178 		"/>
		<polyline points="149.562,191.575 96.596,191.575 96.596,192.241 149.625,192.241 		"/>
		<polyline points="148.959,173.533 148.959,192.241 149.625,192.241 149.625,173.511 		"/>
	</g>
	<text transform="matrix(1 0 0 1 114.8203 188.334)" font-family="Montserrat" font-size="5.261">A-261</text>
	<text transform="matrix(1 0 0 1 99.1309 182.1455)" font-family="Montserrat" font-size="4.7379">Intelepeer Cloud</text>
</g>
<g>
	<rect x="96.93" y="140.167" fill="#8FC3E1" width="52.362" height="18.064"/>
	<g>
		<polyline points="96.596,139.856 96.596,158.564 97.263,158.564 97.263,139.834 		"/>
		<polyline points="149.562,139.834 96.596,139.834 96.596,140.5 149.625,140.5 		"/>
		<polyline points="149.562,157.897 96.596,157.897 96.596,158.564 149.625,158.564 		"/>
		<polyline points="148.959,139.856 148.959,158.564 149.625,158.564 149.625,139.834 		"/>
	</g>
</g>
<g>
	<rect x="140.019" y="153.5" width="7.688" height="7.688"/>
	<path fill="#FFFFFF" d="M142.933,154.093c-0.024-0.031-0.069-0.051-0.118-0.051s-0.094,0.02-0.119,0.051l-0.644,0.843
		c-0.025,0.032-0.025,0.071,0,0.103c0.023,0.033,0.069,0.052,0.118,0.052h0.309v0.78h0.684v-0.78h0.296
		c0.049,0,0.095-0.019,0.118-0.052c0.025-0.031,0.025-0.07,0-0.103L142.933,154.093z"/>
	<path fill="#FFFFFF" d="M144.793,155.818c0.024,0.033,0.07,0.052,0.119,0.052c0.049,0,0.093-0.019,0.118-0.052l0.644-0.843
		c0.025-0.031,0.025-0.07,0-0.102c-0.023-0.032-0.068-0.053-0.118-0.053h-0.309v-0.779h-0.684v0.779h-0.297
		c-0.049,0-0.094,0.021-0.118,0.051c-0.024,0.033-0.024,0.072,0,0.104L144.793,155.818z"/>
	<path fill="#FFFFFF" d="M146.387,156.193h-5.048c-0.43,0-0.778,0.349-0.778,0.778v2.896c0,0.429,0.349,0.778,0.778,0.778h5.048
		c0.43,0,0.778-0.35,0.778-0.778v-2.896C147.166,156.542,146.817,156.193,146.387,156.193 M146.387,156.49
		c0.265,0,0.48,0.217,0.48,0.481v2.896c0,0.265-0.216,0.48-0.48,0.48h-5.048c-0.265,0-0.48-0.216-0.48-0.48v-2.896
		c0-0.265,0.216-0.481,0.48-0.481H146.387z"/>
	<path fill="#FFFFFF" d="M143.294,157.405c0-0.359-0.234-0.538-0.522-0.538c-0.288,0-0.521,0.179-0.521,0.538
		C142.251,158.119,143.294,158.119,143.294,157.405"/>
	<path fill="#FFFFFF" d="M143.195,158.134c-0.078-0.033-0.196-0.052-0.32-0.06h-0.205c-0.125,0.008-0.243,0.026-0.32,0.06
		c-0.458,0.192-0.373,0.8-0.373,1.276c0,0.11,0.072,0.205,0.164,0.219c0.007,0.001,0.014,0.001,0.022,0.001
		c0.101,0,0.187-0.098,0.187-0.22l0.091,0.624c0,0.088,0.051,0.16,0.115,0.16h0.433c0.063,0,0.115-0.072,0.115-0.16l0.091-0.624
		c0,0.11,0.071,0.205,0.164,0.219c0.007,0.001,0.015,0.001,0.021,0.001c0.1,0,0.187-0.098,0.187-0.22
		C143.568,158.924,143.653,158.326,143.195,158.134"/>
	<path fill="#FFFFFF" d="M145.476,157.405c0-0.359-0.234-0.538-0.522-0.538s-0.522,0.179-0.522,0.538
		C144.432,158.119,145.476,158.119,145.476,157.405"/>
	<path fill="#FFFFFF" d="M145.377,158.134c-0.078-0.033-0.196-0.052-0.321-0.06h-0.204c-0.125,0.008-0.243,0.026-0.32,0.06
		c-0.458,0.192-0.373,0.8-0.373,1.276c0,0.11,0.072,0.205,0.164,0.219c0.007,0.001,0.014,0.001,0.022,0.001
		c0.1,0,0.187-0.098,0.187-0.22l0.091,0.624c0,0.088,0.052,0.16,0.115,0.16h0.434c0.063,0,0.114-0.072,0.114-0.16l0.091-0.624
		c0,0.11,0.072,0.205,0.164,0.219c0.008,0.001,0.014,0.001,0.021,0.001c0.1,0,0.188-0.098,0.188-0.22
		C145.75,158.924,145.835,158.326,145.377,158.134"/>
</g>
<g>
	<rect x="140.019" y="162.359" width="7.688" height="7.688"/>
	<path fill="#FFFFFF" d="M142.934,162.952c-0.024-0.031-0.07-0.051-0.119-0.051s-0.094,0.02-0.118,0.051l-0.645,0.843
		c-0.024,0.032-0.024,0.071,0,0.103c0.023,0.033,0.069,0.052,0.118,0.052h0.309v0.78h0.683v-0.78h0.298
		c0.048,0,0.094-0.019,0.117-0.052c0.025-0.031,0.025-0.07,0-0.103L142.934,162.952z"/>
	<path fill="#FFFFFF" d="M144.794,164.678c0.024,0.032,0.069,0.052,0.118,0.052c0.049,0,0.094-0.02,0.118-0.052l0.644-0.843
		c0.025-0.031,0.025-0.07,0-0.103c-0.023-0.032-0.069-0.052-0.118-0.052l-0.308-0.001v-0.778h-0.685v0.778h-0.296
		c-0.049,0-0.095,0.021-0.119,0.052c-0.024,0.033-0.024,0.072,0,0.104L144.794,164.678z"/>
	<path fill="#FFFFFF" d="M146.388,165.053h-5.048c-0.43,0-0.778,0.349-0.778,0.778v2.896c0,0.429,0.348,0.779,0.778,0.779h5.048
		c0.43,0,0.779-0.351,0.779-0.779v-2.896C147.167,165.401,146.817,165.053,146.388,165.053 M146.388,165.35
		c0.265,0,0.481,0.216,0.481,0.481v2.896c0,0.265-0.216,0.48-0.481,0.48h-5.048c-0.265,0-0.48-0.216-0.48-0.48v-2.896
		c0-0.266,0.216-0.481,0.48-0.481H146.388z"/>
	<path fill="#FFFFFF" d="M143.295,166.264c0-0.358-0.234-0.537-0.522-0.537s-0.521,0.179-0.521,0.537
		C142.251,166.979,143.295,166.979,143.295,166.264"/>
	<path fill="#FFFFFF" d="M143.195,166.993c-0.078-0.033-0.195-0.052-0.32-0.06h-0.204c-0.125,0.008-0.243,0.026-0.321,0.06
		c-0.458,0.191-0.373,0.799-0.373,1.275c0,0.11,0.072,0.206,0.165,0.219c0.007,0.002,0.014,0.002,0.021,0.002
		c0.101,0,0.187-0.098,0.187-0.221l0.091,0.625c0,0.088,0.051,0.16,0.115,0.16h0.433c0.063,0,0.115-0.072,0.115-0.16l0.091-0.625
		c0,0.111,0.072,0.206,0.164,0.219c0.008,0.002,0.015,0.002,0.021,0.002c0.101,0,0.187-0.098,0.187-0.221
		C143.568,167.783,143.654,167.185,143.195,166.993"/>
	<path fill="#FFFFFF" d="M145.476,166.264c0-0.358-0.234-0.537-0.522-0.537c-0.287,0-0.521,0.179-0.521,0.537
		C144.433,166.979,145.476,166.979,145.476,166.264"/>
	<path fill="#FFFFFF" d="M145.377,166.993c-0.078-0.033-0.195-0.052-0.32-0.06h-0.205c-0.125,0.008-0.243,0.026-0.32,0.06
		c-0.458,0.191-0.373,0.799-0.373,1.275c0,0.11,0.072,0.206,0.164,0.219c0.008,0.002,0.015,0.002,0.022,0.002
		c0.101,0,0.187-0.098,0.187-0.221l0.091,0.625c0,0.088,0.052,0.16,0.115,0.16h0.434c0.063,0,0.115-0.072,0.115-0.16l0.091-0.625
		c0,0.111,0.072,0.206,0.164,0.219c0.008,0.002,0.015,0.002,0.021,0.002c0.101,0,0.188-0.098,0.188-0.221
		C145.75,167.783,145.835,167.185,145.377,166.993"/>
</g>
<polygon v-on:click="clickStore($event)" id="C-236" class="cls-26 cls0-26" points="575.74 100.81 575.86 94.95 596.34 94.95 593.15 94.84 593.47 92.35 596.34 92.22 596.27 83 569.13 83 561.48 90.7 543.92 90.7 543.92 102.5 552.79 110.93 570.16 110.87 571.12 110.84 571.28 100.77 575.74 100.81"/>
  <polygon v-on:click="clickStore($event)" id="C-212" class="cls-26 cls0-26" points="472.52 113.83 463.74 105.28 463.74 148.78 488.04 148.86 497.3 141.07 497.3 113.83 472.52 113.83"/>
  <polygon v-on:click="clickStore($event)" id="C-262" class="cls-26 cls0-26" points="486.31 154.84 486.31 198.13 488.48 197.64 497.31 195.85 504.59 194.19 529.51 188.54 529.51 154.81 486.31 154.84"/>
  <polygon v-on:click="clickStore($event)" id="B-218" class="cls-29 cls0-29" points="272.58 80.18 272.58 89.89 268.29 89.89 268.29 103.23 273.27 103.23 284.3 114.27 284.34 121.1 299.16 135.82 302.17 135.82 301.98 110.95 300.41 110.95 300.41 110.79 300.41 106.86 284.67 91.08 284.67 90.95 284.62 90.9 284.67 82.87 284.67 80.18 272.58 80.18"/>
  <polygon v-on:click="clickStore($event)" id="B-228" class="cls-29 cls0-29" points="332.35 62.89 325.8 61.37 320.04 60.31 316.3 59.24 313.84 58.64 309.05 58.44 306.29 58.53 302.92 59.15 299.9 60.13 296.88 61.2 294.12 62.62 291.4 64.54 289.6 67.18 287.62 69.65 285.91 72.33 284.72 74.78 284.62 90.9 300.41 106.86 300.41 110.95 302.1 110.95 302.24 111 302.24 110.98 317.46 110.82 348.04 110.87 348.04 66.69 332.35 62.89"/>
  <polygon v-on:click="clickStore($event)" id="B-240" class="cls-29 cls0-29" points="416.2 89.11 415.64 89.11 415.57 76.27 413.23 76.22 411.03 76.22 411.03 80.96 411.03 80.96 411.03 80.96 390.94 80.96 390.94 113.45 386.65 113.45 386.65 119.9 364.76 119.9 364.76 142.6 371.45 149.44 387.9 149.36 388.74 149.36 391.05 149.27 390.97 135.84 397.35 135.84 399.81 135.84 401.42 137.37 415.72 137.37 415.73 137.76 416.2 137.37 416.2 89.11"/>
  <polygon v-on:click="clickStore($event)" id="B-254" class="cls-29 cls0-29" points="397.23 202.07 416.17 202.07 416.13 175.43 415.98 165.29 397.3 165.29 397.3 154.91 389 154.84 387.92 154.99 371.71 154.91 367.78 158.64 364.79 161.45 364.79 162.14 364.83 174.73 371.8 174.73 397.23 202.07"/>
  <polygon v-on:click="clickStore($event)" id="B-260" class="cls-29 cls0-29" points="415.62 201.84 396.9 201.84 371.47 174.5 364.1 174.5 364.1 191.44 284.2 191.76 284.39 226.81 306.45 232.35 332.64 238.69 352.08 243.19 355.32 243.82 359.28 244.59 361.76 244.81 366.3 244.63 369.32 244 371.07 243.28 374.54 241.48 377.19 239.59 380.39 236.49 382.14 233.79 383.22 230.95 384.08 226.72 384.45 223.03 410.85 223.03 410.85 227.53 415.62 227.62 415.62 201.84"/>
  <polygon v-on:click="clickStore($event)" id="C-270" class="cls-26 cls0-26" points="458.93 154.86 458.93 185.79 459.44 187.42 460.83 190.33 462.19 191.96 463.79 193.93 466.51 196.29 470.7 198.57 475.48 199.67 481.65 199.16 486.31 198.13 486.31 154.84 458.93 154.86"/>
  <polygon v-on:click="clickStore($event)" id="C-272" class="cls-26 cls0-26" points="447.48 154.86 447.63 175.74 444.89 175.67 444.89 185.03 458.74 185.19 458.93 185.79 458.93 154.86 447.48 154.86"/>
  <polygon v-on:click="clickStore($event)" id="C-250" class="cls-26 cls0-26" points="595.77 126.45 593.28 126.51 593.15 124.72 596.47 124.72 596.47 115.97 592.19 115.97 581.02 115.85 570.29 115.91 553.5 115.97 552.6 116.04 543.98 126.38 543.97 134.1 595.78 134.1 595.77 126.45"/>
  <polygon v-on:click="clickStore($event)" id="C-214" class="cls-26 cls0-26" points="474.47 97.66 474.47 88.66 444.92 88.71 444.95 89.03 445.27 89.35 448.42 92.18 448.01 96.51 448.01 97.09 455.27 97.04 472.52 113.83 497.3 113.83 497.3 97.66 474.59 97.66 474.47 97.66"/>
  <polygon v-on:click="clickStore($event)" id="C-220" class="cls-26 cls0-26" points="497.37 78.17 499.07 78.14 499.07 70.35 489.83 61.2 479.74 61.2 479.74 49.39 477.01 48.35 477 48.48 444.82 56.78 444.89 88.27 444.91 88.55 445.19 88.66 474.47 88.66 474.59 97.66 497.3 97.66 497.3 95.35 497.37 78.17"/>
  <polygon v-on:click="clickStore($event)" id="C-224" class="cls-26 cls0-26" points="508.47 48.77 508.11 47.52 504.98 47.27 504.98 44.46 476.82 44.52 476.51 48.22 479.25 49.26 479.25 61.08 489.33 61.08 498.57 70.23 498.57 78.01 503.19 77.92 511.88 77.96 511.88 48.89 508.47 48.77"/>
  <polygon v-on:click="clickStore($event)" id="C-230" class="cls-26 cls0-26" points="550.91 61.38 561.79 61.36 561.79 44.59 540.79 44.59 535.23 44.46 535.04 47.08 531.72 47.08 529.04 49.95 529.11 78.17 541.43 78.39 541.43 70.94 550.91 61.38"/>
  <polygon v-on:click="clickStore($event)" id="C-228A" class="cls-26 cls0-26" points="517.6 49.02 512.38 49.02 512.38 63.03 529.01 63.03 529.04 49.19 517.6 49.02"/>
  <polygon v-on:click="clickStore($event)" id="C-228B" class="cls-26 cls0-26" points="512.38 78.09 528.98 78.17 529.01 63.03 512.38 63.03 512.38 65.92 512.38 78.09"/>
  <polygon v-on:click="clickStore($event)" id="B-216" class="cls-29 cls0-29" points="299.46 135.69 284.64 120.97 284.59 114.14 273.57 103.1 268.59 103.1 268.59 148.71 291.01 148.74 302.46 140.05 302.47 135.69 299.46 135.69"/>
  <polygon v-on:click="clickStore($event)" id="C-265" class="cls-26 cls0-26" points="529.51 154.81 529.51 188.54 531.92 188 544.03 185.04 546.92 184.87 547.08 181.68 543.92 154.8 529.51 154.81"/>
  <polygon v-on:click="clickStore($event)" id="C-232" class="cls-26 cls0-26" points="596.21 74.21 591.42 73.83 582.48 44.59 561.79 44.59 561.79 61.36 550.91 61.38 541.43 70.94 541.43 78.39 543.92 78.43 543.92 90.7 561.48 90.7 569.13 83 596.27 83 596.21 74.21"/>
  
</svg>

    <store-modal
      :title="store.name"
      :image="store.business_image"
      :suite="store.suite"
      :website="store.website"
      :contact="store.contact"
      :phone="store.phone"
      :email="store.email"
      :target="target"
      :targetzone="targetzone"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import StoreModal from '@/components/StoreModal'
export default {
  name: 'floor2',
  components:{
    StoreModal,
  },
  data(){
    return {
      store:'B-100',
	  targetzone:'C-270',
	  target: null,
    }
  },
  methods:{
     hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	},
    clickStore(e) {
		   setTimeout(() => {
                  this.$root.$emit('bv::hide::popover');
            }, 0);
      
            this.targetzone = '';

            let num = document.getElementsByClassName("selected").length;
            if(num){


				      const allChildElementsOfParentWithClass = document.querySelectorAll('.selected');



              allChildElementsOfParentWithClass.forEach((element) => {
                element.classList.remove('selected');
              });	
            }
     
      if (e.target.classList == "cls-23") {
			  var className = "cls-23";
        var bodyClass = "section-23";
			} else if(e.target.classList.contains('cls-26')){
			  var className = "cls-26 cls0-26";
        var bodyClass = "section-26";
			}else if (e.target.classList.contains('cls-29')) {
        
          var className = "cls-29 cls0-29";
          var bodyClass = "section-29";
      }

      e.target.className.baseVal = className+" selected";


      document.body.className = '';
      document.body.classList.add(bodyClass);
      this.target = e.target.id;
      this.store = this.storeData(this.target);

	  this.targetzone = this.target;

	  //alert(this.targetzone);
    // this.$bvModal.show('modal-center');
	 		setTimeout(() => {
                  this.$root.$emit('bv::show::popover',this.targetzone);
                  
            }, 500);
    },
    resetModal() {
      console.log("reset modal");
    },

    storeData(payload) {
      
       
      
        return this.stores.find(x => x.suite === payload)

    },
	showStorePopover(){
          this.targetzone = this.$route.params.id;
        if (typeof(this.$route.params.id) !== 'undefined'){
                let zoneString =  this.targetzone.substring(0, 1);
             
               if (zoneString == "B") {
                    var className = "cls-26";
                      var bodyClass = "section-26";
                } else if(zoneString == "C"){
                    var className = "cls-23";
                      var bodyClass = "section-23";
                }
                document.body.className = '';
                document.body.classList.add(bodyClass);

        
                setTimeout(() => {
                    this.store = this.storeData(this.$route.params.id);
                  
                        this.$root.$emit('bv::show::popover',this.targetzone);
              
                    
                    var d = document.querySelector("polygon#"+this.targetzone); //document.getElementById(this.targetzone);
                    d.className.baseVal = className+' selected';
                  }, 400);
              }
      }
  },
  computed:{
    stores() {
      return this.$store.state.suites;
    }
  },
  mounted() {
    window.addEventListener("contextmenu", (event) => {
      event.preventDefault();
    });
  },
  created: function(){
        if (typeof(this.$route.params.id) !== 'undefined'){
          setTimeout(() => {
			        this.showStorePopover()
          }, 400);    
	      }
  }
}
</script>

<style>

   .selected
   {
    stroke: #002868 !important;
    stroke-width: 1px;
    stroke-linejoin: round;
    fill: rgb(255 255 255 / 33%) !important;
    cursor: pointer;
    fill-opacity: .7 !important;
    }
    
         .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {
        fill: none;
      }

      .cls-1, .cls-2, .cls-3, .cls-4, .cls-6 {
        stroke-miterlimit: 10;
      }

      .cls-1, .cls-3 {
        stroke-width: .3px;
      }

      .cls-1, .cls-4 {
        stroke: #000;
      }

      .cls-7 {
        font-size: 4.97px;
      }

      .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24 {
        font-family: 'Montserrat', sans-serif;
      }

      .cls-7, .cls-8, .cls-9, .cls-10, .cls-13, .cls-15, .cls-17, .cls-18, .cls-23, .cls-24 {
        fill: #000100;
      }

      .cls-25 {
        fill: #fff;
      }

      .cls-8 {
        font-size: 6.78px;
      }

      .cls-2 {
        stroke: #020202;
      }

      .cls-2, .cls-4 {
        stroke-width: .75px;
      }

      .cls-3 {
        stroke: #000100;
      }

      .cls-26 {
        fill: #d9e09e;
      }

      .cls-9, .cls-16 {
        font-size: 5.49px;
      }

      /* .cls-27 {
        font-family: 'Montserrat', sans-serif;
        font-size: 10.99px;
        font-weight: 500;
      } */

      .cls-10, .cls-11 {
        font-size: 5.38px;
      }

      .cls-28 {
        fill: #e5e8e5;
      }

      .cls-12 {
        font-size: 3.5px;
      }

      .cls-13, .cls-22 {
        font-size: 5.49px;
      }
      .cls-5{
      font-size:5px;

      }

      .cls-14, .cls-15 {
        font-size: 4.74px;
      }

      .cls-17 {
        font-size: 3.97px;
      }

      .cls-18, .cls-19 {
        font-size: 4px;
      }

      .cls-20 {
        font-size: 4.5px;
      }

      .cls-29 {
        fill: #c4e1f6;
      }

      .cls-6 {
        stroke: #fff;
        stroke-width: .25px;
      }

      .cls-30 {
        fill: #b3d7ed;
      }

      .cls-31 {
        fill: #8fc3e1;
      }

      .cls-21 {
        font-size: 5px;
      }

      .cls-23 {
        font-size: 4.97px;
      }

      .cls-24 {
        font-size: 3.97px;
      }

      .cls-32 {
        fill: #98a9b4;
      }
      .section-26 .popover{
        transform:translate3d(calc(100% - 140px), 150px, 0px) !important;
      }
      .section-23 .popover{
         top: 50% !important;
        right: 50% !important;
        transform: translate(50%,-50%) !important;
        left: auto !important;
      }
      .cls-23 {
          fill: rgb(217, 224, 158, 0.5);
          fill-opacity: 0.1;
      }


      .cls0-29,.cls0-26{
        fill-opacity: 0.0;
      }
      .fs-11 {
        fill:#000100;
      font-family: 'Montserrat', sans-serif;
      font-size:11px;
      }
    </style>
  